/* src/components/block/broadcastingChannelManagment/BroadcastingChannelSheet.tsx */

import   React                                  , 
       { useState                               , 
         useEffect                              , 
         useRef                                 ,
         useCallback                            ,
		 useMemo                                }  from 'react';
import { afficherLimite } from '../../../dataTypes/adminManagment/quota';
import { BUY_CHANNEL_LABEL ,
         openBuyChannel    } from '../../../utils/utils_channelPurchase';
import { BUY_BROADCASTING_DURATION_LABEL ,
         openBuyBroadcastingDuration    } from '../../../utils/utils_broadcastingDurationPurchase';
import   classNames                                from 'classnames';

import   styles                                    from './BroadcastingChannelSheet.module.scss';

import   Window                                    from '../../widget/windows/window';
import   AnimatedWaitingIcon2                      from '../../widget/animations/animatedWaitingIcon2';
import   Tabs2                                     from '../../widget/navigation/Tabs2';

import   BroadcastedMediaListV2                    from './BroadcastedMediaListV2';

import { clearMediartcLocalStorage              }  from '../../../contexts/utils';

import { BackendResponse                        ,
         handleError                            }  from '../../../dataTypes/backendServicesManagment/types';
		 
import { MediaCategory                          , 
         Media                                  }  from '../../../dataTypes/mediaManagment/types';

import { Keyword                                }  from '../../../dataTypes/keywordManagment/types';
         
import { Product                                ,
         ProductVariant                         ,
         ProductPrice                       }  from '../../../dataTypes/productManagment/types';
         
import { EnrichedBroadcastedMedia               , 
         EnrichedBroadcastingChannel            , 
         initializedEnrichedBroadcastingChannel , 
         BroadcastingChannelCategory            ,
         TaggedEnrichedBroadcastedMedia         ,
         StreamSource                           }  from '../../../dataTypes/broadcastingManagment/types';

import { mergeBroadcastedMediasPreservingLocal  }  from '../../../dataTypes/broadcastingManagment/utils';

import { UserStatus                             }  from '../../../dataTypes/userManagment/types';
import { convertDateToString                    ,
         formatDurationInSeconds                }  from '../../../dataTypes/timeManagment/utils';

import { getMediaList                           }  from '../../../backendServices/mediaManagment/api';

import { getMediaCategories                     }  from '../../../backendServices/mediaManagment/api_category';

import { getEnrichedBroadcastingChannel         , 
         createBroadcastingChannel              , 
         updateBroadcastingChannel              ,
         getCurrentAndNextBroadcastedMedias     ,
         getCurrentStreamMetadata               ,
         updateBroadcastingChannelStreamSource  ,
         updateBroadcastingChannelVisibility    ,
         updateBroadcastingChannelPublicPortal  ,
         getBroadcastingChannelMetricsStatus    ,
         updateBroadcastingChannelMetrics       }  from '../../../backendServices/broadcastingManagment/api_broadcastingChannel';




import { getBroadcastingChannelCategories       }  from '../../../backendServices/broadcastingManagment/api_category';
         
import { addBroadcastedMedia                    , 
         deleteBroadcastedMedia                 , 
         updateBroadcastedMedia                 , 
         setBroadcastedMediaLoop                ,
         archiveBroadcastedMedia                }  from '../../../backendServices/broadcastingManagment/api_broadcastedMedia';
import { correctLoopRelease                     }  from '../../../dataTypes/broadcastingManagment/scheduleOperations';

import { getKeywords                            }  from '../../../backendServices/keywordManagment/api';

import { getUserStatusList                      }  from '../../../backendServices/userManagment/api';

import { createProduct                          ,
         updateProduct                          ,
         updateProductVisibility                }  from '../../../backendServices/productManagment/api_product';
		 
import  LiveStreamManagerBootstrap from '../liveStreamManagment/LiveStreamManagerBootstrap';		 
		 
import  BroadcastingChannelCharacteristics_ThirdPartyStreamingSystemV2    from './BroadcastingChannelCharacteristics_ThirdPartyStreamingSystemV2';

import { ThirdPartyStreamingChannel                       }  from '../../../dataTypes/broadcastingManagment/types_thirdPartyStreamingSystem';

import { useMonitorStream      } from '../../../hooks/liveStreamManagment/useMonitorStream';
import { getWatchingUrlHls     ,
         getXtreamConnectionCount } from '../../../backendServices/broadcastingManagment/api_broadcastingChannel';

import { SLIDER_0DB } from '../liveStreamManagment/HlsAudioPanel';

import BroadcastingChannelDashboard from './BroadcastingChannelDashboard';
import { SourceSwitchingContext } from './SourceSelector';
import BroadcastingChannelConfig    from './BroadcastingChannelConfig';


import { useTypedSelector, useTypedDispatch } from '../../../store/useTypeSelector';
import { RootState              } from '../../../store/generalReducer';
import { refreshAdmin           } from '../../../store/adminAuthenticationManagment/actions';

export interface BroadcastingChannelSheetProps {
  broadcastingChannelToEditId? : number;
  defaultPendingBaseImage?     : string;
  onCancel?                    : () => void;
  /** Onglet d'arrivée (0 Tableau de bord … 3 Régie) quand la fiche est ouverte depuis le
   *  Dashboard (2026-10-17) ; sinon l'onglet habituel. */
  initialTabIndex?             : number;
  /** Bouton « Créer une chaîne » du Tableau de bord — posé par la liste quand le créateur
   *  n'a qu'une chaîne et n'arrive donc jamais sur la liste (2026-10-20). */
  onCreateChannel?             : () => void;
  /** Fiche de création : la chaîne vient d'être enregistrée (« Créer la chaîne »). La liste
   *  sait alors qu'il n'y a plus rien à perdre en quittant la fiche. */
  onCreated?                   : (id: number) => void;
  /** Fiche de création : la question « l'activer maintenant ? » a reçu sa réponse — la
   *  liste reprend la main et se réaffiche (2026-10-21). */
  onCreationDone?              : () => void;
}

// `payload.active` du backend ne dit PAS ce que l'opérateur a demandé : BroadcastingChannel::getActive()
// renvoie l'état réel du container Docker, qui reste running pendant toute la phase 'deactivating'.
// Le front, lui, utilise `active` comme intention BDD (optimiste dès le clic) — c'est elle qui pilote
// MonitorVideoPlayer. Prendre `payload.active` tel quel rebasculait donc `active` à true pendant la
// désactivation, et le lecteur retour repartait en état 'starting' : le libellé sous l'icône d'attente
// affichait "Démarrage de la chaîne" au lieu de "Arrêt de la chaîne" pendant tout l'arrêt.
// On dérive l'intention du channelStatus, seul champ qui distingue les deux.
const activeIntentFromStatus = (status: string, fallback: boolean): boolean => {
  switch (status) {
    case 'inactive':
    case 'deactivating':
    case 'deactivating_restricted':
      return false;
    case 'active':
    case 'restricted':
    case 'activating':
    case 'activating_restricted':
    case 'error':
      return true;
    default:
      return fallback;
  }
};

// Le scheduler ffmpeg peut décaler en mémoire l'heure réelle de diffusion d'un programme (ex:
// stratégie 'shift_all' appliquée à la suppression/modification d'un programme antérieur sur le
// même canal) sans jamais répercuter ce décalage sur `broadcastDate` en BDD. Le statut backend
// (failed/skipped/not_found) peut donc arriver alors que l'heure affichée au front n'est pas
// encore passée. On ne fait confiance à ces statuts pour retirer un programme du planning que si
// sa fenêtre de diffusion affichée (broadcastDate → broadcastDate + duration) est bien terminée.
const hasBroadcastWindowPassed = (broadcastedMedia: { broadcastDate: Date | string | null; duration: number }, now: Date): boolean => {
  if (!broadcastedMedia.broadcastDate) return true;
  const endDate = new Date(new Date(broadcastedMedia.broadcastDate).getTime() + broadcastedMedia.duration * 1000);
  return now >= endDate;
};

// Le scheduler ffmpeg peut échouer à lancer une vidéo (conflit avec une vidéo encore en
// cours, dépassement de créneau) sans jamais notifier admin-api (trou côté microservice,
// cf. scheduler.py — un webhook 'video_failed' manquait sur 3 chemins d'échec) : le statut
// backend reste alors "queued"/"current" indéfiniment, même bien après la fin réelle de la
// fenêtre. On ne bascule ces statuts en "missed" qu'avec une marge confortable au-delà de la
// fenêtre affichée — un simple dépassement de chaînage ffmpeg (observé en conditions
// réelles : ~40s sur une vidéo de 91s) ne doit jamais être confondu avec un programme
// réellement orphelin.
const STUCK_QUEUED_SAFETY_MARGIN_MS = 5 * 60 * 1000; // 5 minutes

const hasBeenStuckPastWindow = (broadcastedMedia: { broadcastDate: Date | string | null; duration: number }, now: Date): boolean => {
  if (!broadcastedMedia.broadcastDate) return true;
  const endDate = new Date(new Date(broadcastedMedia.broadcastDate).getTime() + broadcastedMedia.duration * 1000 + STUCK_QUEUED_SAFETY_MARGIN_MS);
  return now >= endDate;
};

export const BroadcastingChannelSheet = ({ broadcastingChannelToEditId, defaultPendingBaseImage, onCancel, initialTabIndex, onCreateChannel, onCreated, onCreationDone }: BroadcastingChannelSheetProps) => {
    
  const [ isEditMode                      , setIsEditMode                      ] = useState(broadcastingChannelToEditId !== undefined);

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  const dispatch           = useTypedDispatch();

  const [ categorySet                     , setCategorySet                     ] = useState<MediaCategory[]>([]);
  const [ keywordSet                      , setKeywordSet                      ] = useState<Keyword[]>([]);
  const [ mediaSet                        , setMediaSet                        ] = useState<Media[]>([]);

  // ── Catégories de chaîne et statuts utilisateur pour le Dashboard ─────────
  const [ bcCategories                    , setBcCategories                    ] = useState<BroadcastingChannelCategory[]>([]);
  const [ userStatuses                    , setUserStatuses                    ] = useState<UserStatus[]>([]);
  
  const [ broadcastingChannelId           , setBroadcastingChannelId           ] = useState<number>(broadcastingChannelToEditId ?? 0);
  const [ enrichedBroadcastingChannel     , setEnrichedBroadcastingChannel     ] = useState<EnrichedBroadcastingChannel>(initializedEnrichedBroadcastingChannel());
  const [ taggedEnrichedBroadcastedMedias , setTaggedEnrichedBroadcastedMedias ] = useState<TaggedEnrichedBroadcastedMedia[]>([]);

  const [ showWaitingIcon                 , setShowWaitingIcon                 ] = useState(false);
  const [ version                         , setVersion                         ] = useState(0);
  const [                          , setMessage                         ] = useState("");
  const [ ready                           , setReady                           ] = useState(false);
  const [ informationMessage              , setInformationMessage              ] = useState(0);
  // Refus d'allumage d'une chaîne verrouillée par l'équipe Kleon (2026-10-17) : le
  // message vient tel quel du serveur (motif du verrou compris).
  const [ lockRefusal                     , setLockRefusal                     ] = useState('');
  const [ quotaRefusalMessage             , setQuotaRefusalMessage             ] = useState('');
  // Compte rendu de l'action « Acheter une chaîne ». Affiché dans une fenêtre
  // applicative plutôt qu'en window.alert, la fiche en disposant déjà.
  const [ purchaseNotice                  , setPurchaseNotice                  ] = useState('');
  // Incrémenté à chaque sauvegarde réussie (création ou modification) — signale à BroadcastingChannelConfig
  // qu'il doit relire broadcastingChannelToEdit et réinitialiser son formulaire (cf. onBroadcastingChannelChange ci-dessous).
  const [ configSaveVersion                , setConfigSaveVersion               ] = useState(0);
  const [ buttonToClick                   , setButtonToClick                   ] = useState(false);

  const [ thirdPartyStreamingChannels     , setThirdPartyStreamingChannels     ] = useState<ThirdPartyStreamingChannel []> ( []);

  // ── Source active et source par défaut — état maître unique du Sheet ─────
  const [ streamSource        , setStreamSource        ] = useState<StreamSource>('video');
  const [ defaultStreamSource , setDefaultStreamSource ] = useState<StreamSource>('video');

  // ── Active et portail — transmis au Dashboard, synchronisés avec enrichedBroadcastingChannel ──
  const [ active        , setActive         ] = useState(false);
  // Source demandée que le serveur n'a pas pu mettre à l'antenne (repli sur la playlist).
  const [ sourceFallback , setSourceFallback ] = useState<{ requested: StreamSource; actual: StreamSource; lost?: boolean } | null>(null);
  // Source en cours de bascule (roue d'attente sur son bouton, cf. SourceSelector).
  const [ sourceSwitching , setSourceSwitching ] = useState<StreamSource | null>(null);
  const [ channelStatus , setChannelStatus  ] = useState<'active' | 'restricted' | 'activating' | 'activating_restricted' | 'inactive' | 'deactivating' | 'deactivating_restricted' | 'error'>('inactive');
  const [ publicPortal  , setPublicPortal   ] = useState(false);

  // ── Mesure (metrics CPU/mémoire du ffmpeg-microservice) — état vivant du
  // container, pas une donnée persistée en base comme publicPortal ci-dessus.
  const [ metricsEnabled   , setMetricsEnabled   ] = useState(false);
  const [ metricsReachable , setMetricsReachable ] = useState(false);

  // ── Volume et mute — source de vérité partagée entre les deux HlsAudioPanel ──
  const [ hlsVolume , setHlsVolume ] = useState(SLIDER_0DB);
  const [ hlsMuted  , setHlsMuted  ] = useState(true);
  
  const [activeTabIndex, setActiveTabIndex] = useState(isEditMode ? (initialTabIndex ?? 0) : 1);

  /*
  const defaultPendingImage = useDefaultPendingImage(
    defaultPendingBaseImage,
    enrichedBroadcastingChannel.name,
  );
  */

  const defaultPendingImage = './images/defaultWaitingImage.png';
  

  const liveStreamStartRef = useRef<() => void>(() => {});
  const liveStreamStopRef  = useRef<() => void>(() => {});

  // Dernier broadcastingChannelId réellement chargé par init() — permet de
  // distinguer un rafraîchissement (version++ après une action sur LE MÊME
  // canal, où l'on veut préserver les items id===0 pas encore sauvegardés)
  // d'un vrai changement de canal édité (BroadcastingChannelSheet n'a pas de
  // `key` dans BroadcastingChannelList.tsx, donc la même instance peut être
  // réutilisée d'un canal à l'autre — sans ce garde-fou, un item id===0 en
  // cours de saisie sur le canal A "fuirait" dans la liste du canal B).
  const lastLoadedChannelIdRef = useRef<number | undefined>(undefined);

  // La chaîne que la fiche est censée montrer À CET INSTANT. init() est asynchrone :
  // sans ce repère, une réponse partie pour la chaîne A et arrivée après celle de B
  // écrase B — et comme plus rien ne relit ensuite, la fiche reste sur A jusqu'au
  // rechargement de la page. Un ref et non un état : il doit être à jour dans une
  // fonction déjà en vol, pas au prochain rendu.
  const currentChannelIdRef = useRef<number>(broadcastingChannelToEditId ?? 0);

  // Etat recording/streaming remonté en temps réel depuis LiveStreamManager (onglet
  // "Régie Tubemarket", potentiellement masqué) — lu au clic sur "désactiver la chaîne"
  // (cf. handleActiveToggle) pour signaler à l'utilisateur, quel que soit l'onglet actif.
  const liveStatusRef = useRef({ isRecording: false, isStreaming: false });
  const [deactivationNotice, setDeactivationNotice] = useState<string | null>(null);

  // L'onglet Régie reste monté (`keepMounted`) : son propre effet de démarrage WHIP
  // ne s'y déclenche donc qu'une fois, à la première apparition d'une source. Revenir
  // sur l'onglet plus tard ne le refait pas tourner, donc lui seul ne peut pas
  // reprévenir l'opérateur. On le fait ici, à chaque clic sur l'onglet.
  const [regieInactiveNotice, setRegieInactiveNotice] = useState<string | null>(null);
  // Case de la question « activer la chaîne ? » posée par l'onglet Régie : afficher aussi la
  // chaîne sur le portail public. Cochée par défaut, remise à zéro à chaque question.
  const [publishOnPortalWithActivation, setPublishOnPortalWithActivation] = useState(true);
  // Même case sur la question posée juste après la création (informationMessage === 1).
  useEffect(() => { if (informationMessage === 1) setPublishOnPortalWithActivation(true); }, [informationMessage]);

  // cf. makeUpdateChannelSchedule() : les nouvelles vidéos ("to create") sont chaînées
  // localement (getDateAndTimeAfterLastBroadcastedMedia) à partir d'un seul ancrage "now"
  // pris au tout premier ajout — si l'utilisateur met plus de temps à composer la liste que
  // la somme des durées déjà ajoutées, l'heure prévue des premières vidéos de la chaîne se
  // retrouve dans le passé avant même l'envoi. On ne recale plus ces heures : on avertit
  // simplement l'utilisateur que ces vidéos ne seront pas diffusées (fenêtre entièrement
  // dépassée) ou démarreront en cours (fenêtre déjà entamée) — la programmation initiale
  // est envoyée telle quelle, le microservice ffmpeg gère lui-même le skip/seek.
  const [scheduleDriftNotice, setScheduleDriftNotice] = useState<string | null>(null);

  // Intention en cours (activer/désactiver) et instant de la demande — cf. handleActiveToggle
  // et le polling ci-dessous : le temps que le backend termine réellement son traitement
  // (docker stop/rm, commit BDD...), une lecture GET concurrente peut renvoyer un statut
  // transitoire allant dans le sens opposé à ce qui vient d'être demandé. On ignore ces
  // lectures contradictoires pendant une courte fenêtre plutôt que de faire régresser l'UI.
  const toggleIntentRef    = useRef<'active' | 'inactive' | null>(null);
  const toggleStartedAtRef = useRef<number>(0);
  const TOGGLE_GRACE_MS    = 15000;
  // Dernière écriture faite DEPUIS cette fiche (enregistrement, portail) : le relevé périodique ne
  // relit pas la fiche juste après, pour ne pas écraser avec une réponse qui date d'avant.
  const lastLocalWriteRef  = useRef<number>(0);

  // ── Flux HLS retour — source unique partagée entre Configuration et Régie ──
  // Le garde porte sur la RÉFÉRENCE, pas sur l'uuid : c'est elle qui compose
  // l'adresse (getWatchingUrlHls), et une chaîne qui n'en a pas encore n'a aucun
  // retour à montrer. Garder l'uuid ici laissait passer une URL vide.
  const monitorHlsUrl = useMemo(
    () => enrichedBroadcastingChannel.publicRef
      ? getWatchingUrlHls(enrichedBroadcastingChannel)
      : '',
    [enrichedBroadcastingChannel.publicRef]
  );
  
  // Le monitor HLS démarre quand le container est confirmé running (channelStatus === 'active'),
  // pas dès le clic optimiste — évite les retries à vide pendant les 15-30s de démarrage du container.
  // Il reste aussi ouvert pendant 'deactivating' : le container n'est détruit qu'à la fin de cette
  // phase côté backend, donc le flux continue d'exister un moment — le couper immédiatement ferait
  // sauter le lecteur retour directement à l'écran de pause au lieu de geler l'image avec l'icône
  // d'attente en attendant l'arrêt réel.
  const { mediaStream: hlsMonitorStream, audioSourceRegistry: hlsAudioRegistry, audioSourceId: hlsAudioSourceId, resetMonitorStream, hasSignal: hlsHasSignal } = useMonitorStream(monitorHlsUrl, channelStatus === 'active' || channelStatus === 'deactivating');

  // Distingue le vrai démarrage (jamais eu de signal depuis le passage à 'active')
  // d'une perte de signal après coup (le signal a été là, puis a disparu) — cf.
  // displayChannelStatus ci-dessous : les deux cas ne doivent pas s'afficher pareil.
  const [hadSignalSinceActive, setHadSignalSinceActive] = useState(false);
  useEffect(() => {
    if (channelStatus !== 'active') { setHadSignalSinceActive(false); return; }
    if (hlsHasSignal) setHadSignalSinceActive(true);
  }, [channelStatus, hlsHasSignal]);

  // Statut affiché au Dashboard : tant que le backend a bien démarré le container
  // (channelStatus === 'active') mais que le flux HLS retour n'est pas encore arrivé,
  // on continue d'afficher "activation en cours" — l'activation n'est vraiment
  // terminée pour l'opérateur que lorsque le signal est visible. Si le signal était
  // déjà arrivé puis a disparu, on affiche "recovering" à la place : ce n'est plus
  // un démarrage normal, l'opérateur doit pouvoir désactiver/relancer la chaîne
  // (cf. disabled du bouton de confirmation dans BroadcastingChannelDashboard).
  const displayChannelStatus = channelStatus === 'active' && !hlsHasSignal
    ? (hadSignalSinceActive ? 'recovering' : 'activating')
    : channelStatus;

  // Note sur la cohérence du lecteur retour pendant la désactivation :
  // `active` (passé tel quel au Dashboard) repasse à `false` dès le clic optimiste, ce qui fait
  // basculer MonitorVideoPlayer en état 'stopping' (dernière image + icône d'attente) — cf.
  // sa machine à états. Comme `hlsMonitorStream` reste alimenté tant que channelStatus vaut
  // 'active' OU 'deactivating' (cf. useMonitorStream ci-dessus), la référence du stream ne change
  // pas pendant cette phase et le lecteur ne saute donc pas directement à l'écran de pause : il ne
  // le fera qu'une fois channelStatus réellement passé à 'inactive', quand hlsMonitorStream devient
  // enfin null.

  useEffect(() => {

    const fetchData = async () => {
      
      try 
       {
        setShowWaitingIcon(true);
        
        const [ mediasResult       , 
                categoriesResult   ,
                keywordsResult     ,
                bcCatResult        ,
                statusResult       ] = await Promise.all([ getMediaList([], authentication.admin?.id) , 
                                                           getMediaCategories()              ,
                                                           getKeywords()                     ,
                                                           getBroadcastingChannelCategories(),
                                                           getUserStatusList()               ]);
        
        if (mediasResult.payload) 
         {
          setMediaSet(mediasResult.payload);
         }
        
        if (categoriesResult.payload) 
         {
          setCategorySet(categoriesResult.payload.sort((a, b) => a.rank - b.rank));
         }
         
        if (keywordsResult.payload) 
         {
          setKeywordSet(keywordsResult.payload);
         }

        if (bcCatResult.code === 1)
         {
          setBcCategories(bcCatResult.payload.sort((a, b) => a.rank - b.rank));
         }

        if (statusResult.code === 1)
         {
          setUserStatuses(statusResult.payload);
         }
         
        await init();
       } 
      catch (error) 
       {
        console.error('Error fetching data:', error);
        setShowWaitingIcon(false);
       }
    };
    fetchData();
  }, []);

  useEffect(() => {
    currentChannelIdRef.current = broadcastingChannelId;
    init();
  }, [broadcastingChannelId, version]);

  // broadcastingChannelId est un ÉTAT initialisé depuis la propriété : sans cet effet, une
  // propriété qui change sans remontage laisserait la fiche sur l'ancienne chaîne pour de
  // bon. Le conteneur porte bien une key aujourd'hui, mais s'en remettre à elle seule fait
  // dépendre la justesse de la fiche d'une décision prise ailleurs.
  useEffect(() => {
    if (broadcastingChannelToEditId !== undefined && broadcastingChannelToEditId !== broadcastingChannelId) {
      setBroadcastingChannelId(broadcastingChannelToEditId);
    }
  }, [broadcastingChannelToEditId]);

  useEffect(() => {
    console.log ("MODIF::",enrichedBroadcastingChannel)
  }, [enrichedBroadcastingChannel]);

  // Polling pendant les états transitoires (activating / deactivating)
  useEffect(() => {
    if ((channelStatus !== 'activating' && channelStatus !== 'deactivating') || !broadcastingChannelId) return;

    const interval = setInterval(async () => {
      const result = await getEnrichedBroadcastingChannel(broadcastingChannelId as number);
      if (result.code === 1) {
        const status = result.payload.channelStatus ?? (result.payload.active ? 'active' : 'inactive');

        // Ignore une lecture qui contredirait la dernière action demandée tant qu'on est
        // dans la fenêtre de grâce : le backend peut mettre quelques secondes à terminer
        // son traitement (arrêt/suppression du container, commit BDD...), et une lecture
        // concurrente peut alors renvoyer un statut transitoire incohérent. Sans ce filtre,
        // l'UI retombe sur l'état opposé et il faut recliquer pour relancer l'action.
        const intent  = toggleIntentRef.current;
        const elapsed = Date.now() - toggleStartedAtRef.current;
        const contradicts =
          (intent === 'active'   && (status === 'inactive' || status === 'deactivating')) ||
          (intent === 'inactive' && (status === 'active'   || status === 'activating'));

        if (contradicts && elapsed < TOGGLE_GRACE_MS) {
          console.log('[régie] Lecture backend ignorée (contredit l\'intention en cours) :', status);
          return;
        }

        // Statut cohérent avec l'intention (ou fenêtre de grâce dépassée) — on peut lever
        // la protection et accepter la lecture.
        toggleIntentRef.current = null;

        const intendedActive = activeIntentFromStatus(status, result.payload.active ?? false);

        setChannelStatus(status);
        setActive(intendedActive);
        setEnrichedBroadcastingChannel(prev => ({ ...prev, active: intendedActive, channelStatus: status }));
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [channelStatus, broadcastingChannelId]);

  // Rafraîchissement périodique de ownerUseFiligrane (reflet de Admin.useFiligrane du
  // créateur propriétaire, cf. types.ts) : ce champ n'est fetché qu'à l'ouverture de la
  // fiche (init(), cf. plus haut) et ne bougerait donc jamais tant que la régie reste
  // ouverte — même après une modification enregistrée depuis la fiche créateur
  // (AdminSheet), qui ne notifie rien à cette fiche chaîne. Poll léger plutôt qu'un
  // canal réactif dédié : le filigrane n'a rien d'urgent, quelques dizaines de
  // secondes de fraîcheur suffisent à éviter le rechargement complet de l'appli.
  //
  // Ce poll réconcilie aussi l'ÉTAT RÉEL de la chaîne. Le statut du navigateur n'est relu qu'au
  // chargement et pendant les transitions déclenchées ici : une chaîne arrêtée du côté serveur
  // (app:broadcasting:shutdown-all, désactivation depuis une autre fiche ou un autre poste,
  // container tombé) restait « active » pour la régie, dont tous les gardes `channelActive`
  // laissaient alors passer des tentatives réseau dans le vide — une WebSocket de signalisation
  // rejouée toutes les 3 s (228 × 404 en 20 min, constaté le 13/10/2026), des sondes HLS, des
  // WHIP en 410. Plus rapide (10 s) tant que la chaîne se croit active, c'est le cas qui coûte.
  const channelStatusRef = useRef(channelStatus);
  useEffect(() => { channelStatusRef.current = channelStatus; }, [channelStatus]);
  const streamSourceRef    = useRef(streamSource);
  const sourceSwitchingRef = useRef(sourceSwitching);
  useEffect(() => { streamSourceRef.current = streamSource; }, [streamSource]);
  useEffect(() => { sourceSwitchingRef.current = sourceSwitching; }, [sourceSwitching]);

  useEffect(() => {
    if (!broadcastingChannelId) return;

    const interval = setInterval(async () => {
      const result = await getEnrichedBroadcastingChannel(broadcastingChannelId as number);
      if (result.code !== 1) return;

      setEnrichedBroadcastingChannel(prev =>
        prev.ownerUseFiligrane === result.payload.ownerUseFiligrane
          ? prev
          : { ...prev, ownerUseFiligrane: result.payload.ownerUseFiligrane }
      );

      // Fiche modifiée ailleurs (appli mobile, autre poste) : présence sur le portail public, nom,
      // description, catégories, mots-clés, accès, chat, plateau. Le Tableau de bord les lit ici ;
      // l'onglet Configuration suit seulement s'il n'a pas de modification en cours.
      if (Date.now() - lastLocalWriteRef.current > 20000) {
        const p = result.payload;
        setEnrichedBroadcastingChannel(prev => {
          const same = prev.publicPortal === p.publicPortal
                    && prev.name === p.name
                    && prev.description === p.description
                    && prev.requiredUserStatusId === p.requiredUserStatusId
                    && prev.chatModeration === p.chatModeration
                    && prev.stageOpen === p.stageOpen
                    && JSON.stringify(prev.categoriesIds) === JSON.stringify(p.categoriesIds)
                    && JSON.stringify(prev.keywordsIds)   === JSON.stringify(p.keywordsIds);
          return same ? prev : { ...prev, publicPortal: p.publicPortal, name: p.name, description: p.description,
                                 requiredUserStatusId: p.requiredUserStatusId, chatModeration: p.chatModeration,
                                 stageOpen: p.stageOpen, categoriesIds: p.categoriesIds, keywordsIds: p.keywordsIds };
        });
        setPublicPortal(prev => prev === p.publicPortal ? prev : p.publicPortal);
      }

      // Source perdue côté serveur (OBS coupé : le microservice repasse seul sur la playlist et
      // admin-api bascule sur la source par défaut). Sans cette relecture la fiche restait sur
      // « RTMP » sans un mot (13/10/2026). La régie WebRTC est exclue : sa source se pilote
      // depuis le navigateur, un écart y est transitoire.
      const srvSource = result.payload.streamSource as StreamSource | undefined;
      const curSource = streamSourceRef.current;
      if (srvSource && srvSource !== curSource && !sourceSwitchingRef.current
          && curSource !== 'webrtc' && srvSource !== 'webrtc') {
        console.warn(`[source] Source changée côté serveur : ${curSource} → ${srvSource}`);
        setStreamSource(srvSource);
        setEnrichedBroadcastingChannel(prev => ({
          ...prev,
          streamSource: srvSource,
          mode: srvSource === 'video' ? 'Delayed' : 'Live',
        }));
        setSourceFallback({ requested: curSource, actual: srvSource, lost: true });
        // Le retour reste figé sur l'ancienne source : le second étage a coupé puis republié le
        // path public pendant le repli, et le lecteur HLS ne s'y raccroche pas seul (constaté le
        // 13/10/2026). Même geste que le rafraîchissement manuel du retour ; la sonde du manifeste
        // attend que le flux soit de nouveau servi.
        resetMonitorStream();
      }

      // Réconciliation : seulement hors transition et sans action de l'opérateur en cours —
      // le poll de 4 s ci-dessus (et sa fenêtre de grâce) garde la main pendant un basculement.
      const local  = channelStatusRef.current;
      const stable = (x: string) => x === 'active' || x === 'inactive' || x === 'restricted';
      if (!stable(local) || toggleIntentRef.current !== null) return;
      const server = result.payload.channelStatus ?? (result.payload.active ? 'active' : 'inactive');
      if (!stable(server) || server === local) return;

      console.warn(`[régie] Statut de la chaîne changé côté serveur : ${local} → ${server}`);
      const intendedActive = activeIntentFromStatus(server, result.payload.active ?? false);
      setChannelStatus(server);
      setActive(intendedActive);
      setEnrichedBroadcastingChannel(prev => ({ ...prev, active: intendedActive, channelStatus: server }));
    }, channelStatus === 'active' ? 10000 : 30000);

    return () => clearInterval(interval);
  }, [broadcastingChannelId, channelStatus, resetMonitorStream]);

  // Nombre de viewers Xtream connectés — pertinent uniquement chaîne active
  const [xtreamViewerCount, setXtreamViewerCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (channelStatus !== 'active' || !broadcastingChannelId) {
      setXtreamViewerCount(undefined);
      return;
    }

    let cancelled = false;

    const fetchCount = async () => {
      const result = await getXtreamConnectionCount(broadcastingChannelId as number);
      if (!cancelled && result.code === 1) {
        setXtreamViewerCount(result.payload.activeConnections);
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, 15000);

    return () => { cancelled = true; clearInterval(interval); };
  }, [channelStatus, broadcastingChannelId]);

  // État du système de mesure ffmpeg-microservice — interrogeable
  // uniquement chaîne active (container arrêté sinon, cf. reachable=false).
  useEffect(() => {
    if (channelStatus !== 'active' || !broadcastingChannelId) {
      setMetricsEnabled(false);
      setMetricsReachable(false);
      return;
    }

    let cancelled = false;

    const fetchMetricsStatus = async () => {
      const result = await getBroadcastingChannelMetricsStatus(broadcastingChannelId as number);
      if (!cancelled && result.code === 1) {
        setMetricsEnabled(result.payload.enabled);
        setMetricsReachable(result.payload.reachable);
      }
    };

    fetchMetricsStatus();
    const interval = setInterval(fetchMetricsStatus, 15000);

    return () => { cancelled = true; clearInterval(interval); };
  }, [channelStatus, broadcastingChannelId]);

  const handleMetricsToggle = useCallback(async (v: boolean) => {
    // Optimistic update
    setMetricsEnabled(v);

    try {
      const result = await updateBroadcastingChannelMetrics(broadcastingChannelId, v);
      if (result.code === 1) {
        setMetricsEnabled(result.payload.enabled);
        setMetricsReachable(result.payload.reachable);
      } else {
        // Rollback
        setMetricsEnabled(!v);
      }
    } catch {
      // Rollback
      setMetricsEnabled(!v);
    }
  }, [broadcastingChannelId]);

  const enrichBroadcastedMediasWithTags = (broadcastedMedias: EnrichedBroadcastedMedia[]) => {

    // « Jouer en boucle » : un programme en boucle n'a pas de fin, et ceux qui le suivent sont
    // retenus par le microservice jusqu'à sa désactivation. Aucun n'est « resté bloqué » au-delà
    // de sa fenêtre (hasBeenStuckPastWindow) : les y soumettre les ferait archiver en
    // « Non diffusé » au prochain enregistrement. Début de la première boucle ouverte :
    const loopStartMs = broadcastedMedias
      .filter(m => m.loop && m.broadcastDate && ['pending', 'queued', 'current', 'not_broadcasted'].includes(m.status))
      .reduce((min, m) => Math.min(min, new Date(m.broadcastDate as Date).getTime()), Infinity);

    return broadcastedMedias.map((broadcastedMedia) => {

      let   tag           = "";
      const now           = new Date();
      const beginningDate = broadcastedMedia.broadcastDate ? new Date(broadcastedMedia.broadcastDate) : null;
      const endDate       = beginningDate ? new Date(beginningDate.getTime() + broadcastedMedia.duration * 1000) : null;
      const windowPassed  = hasBroadcastWindowPassed(broadcastedMedia, now);

      // Archive du jour, gardée pour le bloc d'un « Lire maintenant » (keepPriorityArchives) :
      // déjà sortie du planning, rien à y faire à l'enregistrement.
           if ( broadcastedMedia.archived                 ) { tag = "archived";   }
      else if ( broadcastedMedia.status === 'broadcasted' ) { tag = "to archive"; }
      // 'queued'/'current' : normalement des statuts transitoires légitimes, mais un échec de
      // lancement jamais notifié à admin-api (cf. commentaire de hasBeenStuckPastWindow) peut les
      // y laisser bloqués pour toujours. Au-delà de la marge de sécurité, on les traite comme
      // "missed" pour qu'ils soient nettoyés au prochain passage sur l'onglet Programmation.
      else if ( broadcastedMedia.status === 'queued' || broadcastedMedia.status === 'current' ) {
        const heldByLoop = !!beginningDate && beginningDate.getTime() >= loopStartMs;

        if (!heldByLoop && hasBeenStuckPastWindow(broadcastedMedia, now)) {
          tag = "missed";
          console.warn(
            `[programmation] statut backend "${broadcastedMedia.status}" resté bloqué bien au-delà de la fenêtre de diffusion (+${STUCK_QUEUED_SAFETY_MARGIN_MS / 1000}s de marge) — programme #${broadcastedMedia.id} tagué "missed" pour nettoyage automatique.`,
            { broadcastedMediaId: broadcastedMedia.id, status: broadcastedMedia.status, broadcastDate: broadcastedMedia.broadcastDate, endDate, now }
          );
        // La chaîne éteinte ne diffuse plus rien, mais admin-api peut ne jamais notifier
        // le retour à "queued" de ce qui était "current" au moment de l'arrêt (aucun
        // évènement d'arrêt ne le déclenche côté microservice) — sans ce garde-fou, le
        // programme reste affiché "En cours" indéfiniment et la poubelle ne revient jamais.
        } else if (broadcastedMedia.status === 'current' && channelStatus !== 'active' && channelStatus !== 'restricted') {
          tag = "queued";
        } else {
          tag = broadcastedMedia.status;
        }
      }
      // 'pending' : canal inactif au moment de la création, sera poussée au microservice à la
      // prochaine activation — toujours sur le programme, donc affichée comme 'queued'.
      else if ( broadcastedMedia.status === 'pending'     ) { tag = "queued";     }
      // 'not_found'/'failed'/'skipped' : la vidéo n'a jamais (pu) être diffusée. Mais le
      // scheduler ffmpeg peut décaler son horloge interne sans jamais toucher à broadcastDate
      // en BDD (cf. hasBroadcastWindowPassed ci-dessus) — un de ces statuts peut donc arriver
      // AVANT l'heure de diffusion affichée. On ne retire jamais un programme dont la fenêtre
      // affichée n'est pas terminée : on le garde en 'queued' et on logue l'anomalie pour
      // investigation, plutôt que de le faire disparaître/archiver à tort.
      else if ( broadcastedMedia.status === 'not_found' || broadcastedMedia.status === 'failed' || broadcastedMedia.status === 'skipped' ) {
        if (windowPassed) {
          tag = broadcastedMedia.status === 'not_found' ? "not found" : "missed";
        } else {
          tag = "queued";
          console.warn(
            `[programmation] statut backend "${broadcastedMedia.status}" reçu AVANT la fin de la fenêtre de diffusion affichée — programme #${broadcastedMedia.id} conservé en "queued" au lieu d'être retiré du planning.`,
            { broadcastedMediaId: broadcastedMedia.id, status: broadcastedMedia.status, broadcastDate: broadcastedMedia.broadcastDate, endDate, now }
          );
        }
      }

      console.log(
        `[programmation] tag calculé pour broadcastedMedia #${broadcastedMedia.id} : status="${broadcastedMedia.status}" -> tag="${tag}"`,
        { broadcastDate: broadcastedMedia.broadcastDate, endDate, now, windowPassed }
      );

      return {
        ...broadcastedMedia,
        tag: tag,
        oldTag: "",
        selected: false,
      };
    });
  };

  const reload = async () => {

    console.log (' ~~~~~~~~~~ reload')

    if (isEditMode) 
     {
      if (broadcastingChannelId)
       {
        const result2 = await getEnrichedBroadcastingChannel(broadcastingChannelId as number);

        console.log (' ~~~~~~~~~~ reload', result2)
        
        if (result2.code === 1) 
         {
          setEnrichedBroadcastingChannel(result2.payload);
          setThirdPartyStreamingChannels(result2.payload.thirdPartyStreamingChannels);

          // Synchroniser active et publicPortal avec les données fraîches
          setActive      (activeIntentFromStatus(result2.payload.channelStatus ?? '', result2.payload.active ?? false));
          setPublicPortal(result2.payload.publicPortal ?? false);

          // Update fonctionnel (prevTagged) : la fusion s'applique sur l'état React le
          // plus récent au moment réel de l'exécution, jamais sur une copie figée au
          // moment de l'appel à reload() — cf. mergeBroadcastedMediasPreservingLocal,
          // qui préserve aussi tout item id===0 (pas encore sauvegardé) ajouté pendant
          // que ce fetch était en vol.
          const serverTagged = enrichBroadcastedMediasWithTags(result2.payload.broadcastedMedias);
          setTaggedEnrichedBroadcastedMedias(prevTagged =>
            mergeBroadcastedMediasPreservingLocal(prevTagged, serverTagged)
          );
        }
      }

      setVersion(version + 1);

    }
  };

  const init = async () => {
      
    console.log (' ~~~~~~~~~~ init');
	  
    if (isEditMode) 
          {
           if ( broadcastingChannelId )
            {
             const demande = broadcastingChannelId as number;
             const result  = await getEnrichedBroadcastingChannel (demande);

             console.log (' ~~~~~~~~~~ init', result);

             // Entre le départ de la requête et son retour, l'opérateur a pu ouvrir une
             // autre chaîne. Cette réponse-là ne concerne plus la fiche affichée : la
             // prendre y installerait la chaîne précédente, durablement.
             if (demande !== currentChannelIdRef.current)
              {
               console.warn (`réponse ignorée : chaîne ${demande} demandée, ${currentChannelIdRef.current} affichée`);
               return;
              }

             if (result.code === 1)
              {
               setEnrichedBroadcastingChannel(result.payload);

               // Sur un vrai changement de canal édité, on remplace directement (pas de
               // fusion à faire, aucun item local du canal précédent n'a de sens ici).
               // Sur un simple rafraîchissement du MÊME canal (version++ après une mise à
               // jour du programme), on fusionne pour préserver tout item id===0 ajouté
               // pendant que ce fetch était en vol — cf. mergeBroadcastedMediasPreservingLocal.
               const isChannelSwitch = lastLoadedChannelIdRef.current !== broadcastingChannelId;
               lastLoadedChannelIdRef.current = broadcastingChannelId;
               const serverTagged = enrichBroadcastedMediasWithTags(result.payload.broadcastedMedias);
               setTaggedEnrichedBroadcastedMedias(prevTagged =>
                 isChannelSwitch ? serverTagged : mergeBroadcastedMediasPreservingLocal(prevTagged, serverTagged)
               );
               setThirdPartyStreamingChannels(result.payload.thirdPartyStreamingChannels);

               setStreamSource       (result.payload.streamSource        ?? 'video');
               setDefaultStreamSource(result.payload.defaultStreamSource ?? 'video');

               // Initialiser active, channelStatus et publicPortal depuis les données backend
               const initialStatus = result.payload.channelStatus ?? (result.payload.active ? 'active' : 'inactive');
               setActive        (activeIntentFromStatus(initialStatus, result.payload.active ?? false));
               setChannelStatus (initialStatus);
               setPublicPortal  (result.payload.publicPortal  ?? false);
              }
            }
          } 
     else {
           lastLoadedChannelIdRef.current = undefined;
           setEnrichedBroadcastingChannel(initializedEnrichedBroadcastingChannel());
           setTaggedEnrichedBroadcastedMedias([]);
           setStreamSource       ('video');
           setDefaultStreamSource('video');
           setActive        (false);
           setChannelStatus ('inactive');
           setPublicPortal  (false);
          }
          
    setMessage ("");
    setReady(true);
    setButtonToClick(false);
    // Ce init() peut relire enrichedBroadcastingChannel depuis le backend (cas edit) après un
    // changement de broadcastingChannelId ou de version — donc après la création d'une chaîne
    // (setBroadcastingChannelId déclenche cet effet) : il faut resynchroniser le formulaire de
    // BroadcastingChannelConfig sur cette version potentiellement différente de celle déjà reçue.
    setConfigSaveVersion(v => v + 1);
  };

  const handleReady = () => {
    setShowWaitingIcon(false);
  };

  // Chaîne éphémère : l'onglet Configuration n'affiche qu'un message statique (cf. Tabs2
  // plus bas), jamais BroadcastingChannelConfig — qui est la seule chose à appeler onReady
  // (donc handleReady) pour une chaîne normale, même quand Configuration n'est pas l'onglet
  // actif (il reste monté, keepMounted). Sans ce relais, l'icône d'attente posée par le
  // fetchData initial ne s'éteint jamais sur une chaîne éphémère.
  useEffect(() => {
    if (enrichedBroadcastingChannel.ephemeral) handleReady();
  }, [enrichedBroadcastingChannel.ephemeral]);

  const handleSourceChange = async (newSource: StreamSource) => {

    if (!broadcastingChannelId) return;

    // Une bascule est déjà en attente de confirmation : en lancer une seconde ferait répondre
    // « bascule déjà en cours » par le serveur et brouillerait ce que la régie affiche.
    if (sourceSwitching) return;

    // Chaîne à l'arrêt : la régie ne peut ni démarrer ni s'arrêter, le choix est seulement
    // mémorisé. Il s'appliquera au démarrage (la régie se relance seule sur « Régie », le
    // serveur bascule sur « RTMP »).
    // 2026-10-18 : plus de choix à froid. Une chaîne arrêtée reste sur Mire / playlist, la
    // source ne se change qu'une fois le microservice actif (le sélecteur est verrouillé).
    if (channelStatus === 'inactive' || channelStatus === 'deactivating') return;

    const wasStreaming = streamSource === 'webrtc';

    setStreamSource(newSource);
    setEnrichedBroadcastingChannel(prev => ({
      ...prev,
      streamSource: newSource,
      mode: newSource === 'video' ? 'Delayed' : 'Live',
    }));

    if (newSource === 'webrtc' && !wasStreaming) {
      liveStreamStartRef.current();
      return;
    }

    if (newSource !== 'webrtc' && wasStreaming) {
      liveStreamStopRef.current();
      return;
    }

    setSourceSwitching(newSource);
    try {
      await updateBroadcastingChannelStreamSource(broadcastingChannelId, newSource);

      // Le second étage ne bascule que quand la source demandée est PRÊTE côté serveur (OBS
      // connecté sur live_UUID, par exemple) ; sinon il laisse la playlist à l'antenne, et
      // admin-api n'enregistre que la source réellement active. Relire la chaîne est le seul
      // moyen de le savoir : sans cela la régie restait affichée sur « RTMP » alors que c'était
      // la playlist qui passait (13/10/2026 : streaming OBS lancé trop tard).
      const check = await getEnrichedBroadcastingChannel(broadcastingChannelId as number);
      if (check.code === 1) {
        const actual = (check.payload.streamSource ?? newSource) as StreamSource;
        if (actual !== newSource) {
          console.warn(`[source] « ${newSource} » indisponible — la chaîne est restée sur « ${actual} »`);
          setStreamSource(actual);
          setEnrichedBroadcastingChannel(prev => ({
            ...prev,
            streamSource: actual,
            mode: actual === 'video' ? 'Delayed' : 'Live',
          }));
          setSourceFallback({ requested: newSource, actual });
        }
      }
    } catch (e) {
      console.error('[source] Échec du basculement, rollback :', e);
      setStreamSource(prev => prev);
      setEnrichedBroadcastingChannel(prev => ({ ...prev, streamSource: prev.streamSource }));
    } finally {
      setSourceSwitching(null);
    }
  };

  const handleDefaultSourceChange = (newDefault: StreamSource) => {

    console.log('[source] Nouvelle source par défaut :', newDefault);

    setDefaultStreamSource(newDefault);
    setEnrichedBroadcastingChannel(prev => ({
      ...prev,
      defaultStreamSource: newDefault,
    }));
  };

  const handleStopStreaming = useCallback(async () => {
    // La bascule de source au stop est gérée intégralement par LiveStreamManager
    // via onStreamSourceChange → handleSourceChange.
  }, [streamSource, defaultStreamSource, broadcastingChannelId]);

  // ── Handlers volume/mute ──────────────────────────────────────────────────
  const handleHlsVolumeChange = useCallback((v: number) => {
    setHlsVolume(v);
  }, []);

  const handleHlsMutedChange = useCallback((m: boolean) => {
    setHlsMuted(m);
  }, []);

/*
  // ── Handlers active / portail — synchronisent état local ET enrichedBroadcastingChannel ──
  const handleActiveToggle = useCallback(() => {
    const next = !active;
    setActive(next);
    setEnrichedBroadcastingChannel(prev => ({ ...prev, active: next }));
	
	updateBroadcastingChannelVisibility ( broadcastingChannelId , next )  /////////////////////////
	
  }, [active]);
*/

// Le backend committe l'état BDD dès la toute première étape de son traitement (avant les
// opérations lentes : docker stop/rm, HAProxy, MediaMtx — qui peuvent prendre plusieurs dizaines
// de secondes). Si la requête PATCH échoue côté client pendant cette fenêtre (timeout d'un proxy
// intermédiaire, coupure réseau...), l'action a très probablement déjà été prise en compte côté
// serveur. Un rollback aveugle romprait le polling (channelStatus repasserait à 'active'/'inactive',
// qui ne redéclenchent plus le polling) et laisserait l'UI bloquée dans le mauvais état jusqu'à ce
// que l'utilisateur reclique. On revérifie donc l'état réel avant de décider de revenir en arrière.
const confirmOrRollback = useCallback(async (next: boolean) => {
  try {
    const check = await getEnrichedBroadcastingChannel(broadcastingChannelId as number);
    if (check.code === 1) {
      const status = check.payload.channelStatus ?? (check.payload.active ? 'active' : 'inactive');
      const confirmedByBackend =
        (next  && (status === 'active'   || status === 'activating'))   ||
        (!next && (status === 'inactive' || status === 'deactivating'));

      if (confirmedByBackend) {
        // L'action a bien été prise en compte malgré l'échec de la requête — on garde le cap
        // et on laisse le polling habituel prendre le relais.
        const intendedActive = activeIntentFromStatus(status, next);

        setChannelStatus(status);
        setActive(intendedActive);
        setEnrichedBroadcastingChannel(prev => ({ ...prev, active: intendedActive, channelStatus: status }));
        return;
      }
    }
  } catch {
    // Vérification elle-même impossible — on rollback par prudence ci-dessous.
  }

  // Rollback réel : le backend confirme (ou on n'a pas pu vérifier) que l'action n'a pas abouti.
  toggleIntentRef.current = null;
  setActive(!next);
  setChannelStatus(!next ? 'active' : 'inactive');
  setEnrichedBroadcastingChannel(prev => ({ ...prev, active: !next, channelStatus: !next ? 'active' : 'inactive' }));
}, [broadcastingChannelId]);

// Rend true quand le serveur a accepté la demande (code 1) ; false si elle est refusée (quota...)
// ou n'a pas abouti — l'appelant s'en sert pour ne rien enchaîner sur un refus.
const handleActiveToggle = useCallback(async (): Promise<boolean> => {
  // L'intention se lit sur channelStatus (l'intention enregistrée en base) et NON sur
  // `active`, qui reflète l'état du container Docker renvoyé par getActive() côté backend.
  // Une chaîne restée à active=1 en base sans container a active=false : un `!active` y
  // aurait déclenché une ACTIVATION là où l'opérateur demande un arrêt. Même règle dans
  // BroadcastingChannelDashboard (toggleWillDeactivate).
  const next = channelStatus === 'inactive';

  // Signale à l'utilisateur, quel que soit l'onglet actif, qu'un enregistrement et/ou une
  // diffusion en cours vont être arrêtés automatiquement par la désactivation de la chaîne
  // (l'arrêt réel se fait côté LiveStreamManager, cf. son effet sur channelActive).
  if (!next) {
    const { isRecording: wasRecording, isStreaming: wasStreaming } = liveStatusRef.current;

    // Programme de la PLAYLIST à l'antenne : la vérité est celle du microservice
    // (schedule/current : « playing » = une vidéo passe, « idle » = la mire), la même que celle
    // qui pilote le badge « EN COURS » du tableau de bord. Ni liveStatusRef (état de la régie)
    // ni le statut en base ne le disent. Le relevé part AVANT l'arrêt mais ne le retarde pas :
    // il n'a de sens que tant que le container tourne, et une chaîne injoignable ne doit jamais
    // empêcher de l'arrêter — sans réponse (null), on n'affirme rien.
    const publicRef = enrichedBroadcastingChannel.publicRef;
    const currentProgram = (publicRef && channelStatus === 'active')
      ? getCurrentStreamMetadata(publicRef)
      : Promise.resolve(null);

    void currentProgram.then(current => {
      const running: string[] = [];
      if (wasRecording) running.push('un enregistrement');
      if (wasStreaming) running.push('une diffusion en direct depuis la régie');
      if (current?.status === 'playing') {
        running.push(current.media_name ? `le programme « ${current.media_name} » de la playlist` : 'un programme de la playlist');
      }
      if (running.length === 0) return;

      const list = running.length === 1
        ? running[0]
        : `${running.slice(0, -1).join(', ')} et ${running[running.length - 1]}`;
      const sentence = `En cours : ${list}.`;
      setDeactivationNotice(`${sentence} La désactivation de la chaîne va ${running.length === 1 ? "l'arrêter" : 'les arrêter'} automatiquement.`);
    });
  }

  // Optimistic update — état transitoire immédiat
  setActive(next);
  setChannelStatus(next ? 'activating' : 'deactivating');
  setEnrichedBroadcastingChannel(prev => ({ ...prev, active: next, channelStatus: next ? 'activating' : 'deactivating' }));

  // Mémorise l'intention pour que le polling ci-dessous ignore les lectures backend
  // qui iraient temporairement dans le sens opposé (cf. TOGGLE_GRACE_MS).
  toggleIntentRef.current    = next ? 'active' : 'inactive';
  toggleStartedAtRef.current = Date.now();

  let accepted = false;

  try {
    const result = await updateBroadcastingChannelVisibility(broadcastingChannelId, next);
    accepted = result.code === 1;
    if (result.code !== 1) {
      // 409 = refus amont par le backend (quota atteint), avant toute modification —
      // on le signale explicitement plutôt que de laisser le toggle revenir en
      // arrière sans explication. Deux causes possibles distinguées par le texte du
      // message (cf. BroadcastingChannelActivationService::activate) : quota de
      // chaînes actives simultanées, ou quota de durée cumulée de diffusion.
      if (result.code === 409) {
        if (result.comment.includes('verrouillée')) { setLockRefusal(result.comment); setInformationMessage(-7); }
        else setInformationMessage(result.comment.includes('durée de diffusion') ? -6 : -5);
      }
      await confirmOrRollback(next);
    }
    // Pas besoin de setChannelStatus('active'/'inactive') ici : le polling le fera
  } catch {
    await confirmOrRollback(next);
  }

  // L'activation/désactivation consomme ou libère un slot de chaîne côté backend, et
  // la désactivation relâche en plus les devices de la régie : on recharge les
  // compteurs affichés dans le header, qui sinon resteraient ceux du login.
  if (authentication.admin?.email) { dispatch(refreshAdmin(authentication.admin.email)); }

  return accepted;
}, [channelStatus, broadcastingChannelId, enrichedBroadcastingChannel.publicRef, confirmOrRollback, authentication.admin?.email, dispatch]);




  const handlePortalChange = useCallback(async (v: boolean) => {
    lastLocalWriteRef.current = Date.now();
    // Optimistic update
    setPublicPortal(v);
    setEnrichedBroadcastingChannel(prev => ({ ...prev, publicPortal: v }));

    try {
      const result = await updateBroadcastingChannelPublicPortal(broadcastingChannelId, v);
      if (result.code !== 1) {
        // Rollback
        setPublicPortal(!v);
        setEnrichedBroadcastingChannel(prev => ({ ...prev, publicPortal: !v }));
      }
    } catch {
      // Rollback
      setPublicPortal(!v);
      setEnrichedBroadcastingChannel(prev => ({ ...prev, publicPortal: !v }));
    }
  }, [broadcastingChannelId]);

  // Activation + (case cochée) passage sur le portail public. Le portail n'est touché que si
  // le serveur a ACCEPTÉ l'activation : sur un refus (quota de chaînes actives, de durée...),
  // la chaîne resterait sinon visible sur le portail sans être démarrée.
  const activateAndMaybePublish = useCallback(async () => {
    const wantsPortal = !publicPortal && publishOnPortalWithActivation;
    const accepted    = await handleActiveToggle();
    if (accepted && wantsPortal) await handlePortalChange(true);
  }, [publicPortal, publishOnPortalWithActivation, handleActiveToggle, handlePortalChange]);

  const getDateAndTimeAfterLastBroadcastedMedia = (): Date => {
    
    if (taggedEnrichedBroadcastedMedias.length === 0)  
     {
      return new Date();
     }
     
    const lastMedia     = taggedEnrichedBroadcastedMedias[taggedEnrichedBroadcastedMedias.length - 1];
    const beginningDate = lastMedia.broadcastDate;
    const endDate       = new Date((beginningDate ? beginningDate.getTime() : 0) + lastMedia.duration * 1000);
    
    return endDate;
  };
  
  interface BackendResponse_ProductId extends BackendResponse<number> {}

  const saveAssociatedProduct = async ( soldProduct              : boolean ,
                                        title                    : string  ,
                                        soldProductPrice         : number  ,
                                        initialAssociatedProduct : Product | null  ) : Promise<BackendResponse_ProductId> => {
                                         
      if ( soldProduct )
	        {
             let associatedProduct_price   : ProductPrice;
             let associatedProduct_variant : ProductVariant;
             let associatedProduct         : Product;

             if ( isEditMode && initialAssociatedProduct ) 
                   {
                    const variant = initialAssociatedProduct.variants[0];
                    const price   = variant.prices[0];

                    associatedProduct_price   = { 
                                                  id                : price.id,
                                                  name              : price.name,
                                                  requiredStatus    : price.requiredStatus,
                                                  comment           : price.comment,
                                                  code              : price.code,
                                                  active            : price.active,
                                                  creationDate      : price.creationDate,
                                                  basePrice         : soldProductPrice / 1.2 ,
                                                  taxRate           : 20,
                                                  priceWithTax      : soldProductPrice  ,
                                                  discounts         : [],
                                                };

                    associatedProduct_variant = {
                                                  id                : variant.id,
                                                  name              : variant.name,
                                                  complement        : variant.complement,
                                                  description       : variant.description,
                                                  code              : variant.code,
                                                  barcode           : variant.barcode,
                                                  active            : variant.active,
                                                  creationDate      : variant.creationDate,
                                                  stockAvailable    : variant.stockAvailable,
                                                  stockBooked       : variant.stockBooked,
                                                  stockAssigned     : variant.stockAssigned,
                                                  stockThreshold    : variant.stockThreshold,
                                                  characteristics   : variant.characteristics,
                                                  medias            : variant.medias,
                                                  prices            : [associatedProduct_price],
                                                };

                    associatedProduct         = {
                                                  id                   : initialAssociatedProduct.id,
                                                  uuid                 : initialAssociatedProduct.uuid,
                                                  publicRef            : initialAssociatedProduct.publicRef,
                                                  name                 : initialAssociatedProduct.name,
                                                  catchword            : initialAssociatedProduct.catchword,
                                                  code                 : initialAssociatedProduct.code,
                                                  publicPortal         : initialAssociatedProduct.publicPortal,
                                                  active               : true,
                                                  activeScheduled      : initialAssociatedProduct.activeScheduled,
                                                  activeStartDate      : initialAssociatedProduct.activeStartDate,
                                                  activeEndDate        : initialAssociatedProduct.activeEndDate,
                                                  lastUpdateDate       : initialAssociatedProduct.lastUpdateDate, 
                                                  creationDate         : initialAssociatedProduct.creationDate,
                                                  requiredStatus       : initialAssociatedProduct.requiredStatus,
                                                  requiredUserStatusId : initialAssociatedProduct.requiredUserStatusId,
		                                          paymentRequired      : true,
                                                  kind                 : initialAssociatedProduct.kind,
                                                  description          : initialAssociatedProduct.description,
                                                  variants             : [associatedProduct_variant],
                                                  characteristics      : initialAssociatedProduct.characteristics,
                                                  medias               : initialAssociatedProduct.medias,
                                                  categoriesIds        : initialAssociatedProduct.categoriesIds,
                                                  associatedMediaId    : 0,
                                                  associatedBroadcastingChannelId: initialAssociatedProduct.associatedBroadcastingChannelId,
                                                  associatedUserStatusId: 0,
                                                  associatedAdminResource: null
                                                };
   
                    return await updateProduct ( associatedProduct, null, authentication.admin?.id )
                   }
              else {
                    associatedProduct_price   = {
                                                  id                : 0,
                                                  name              : title,
                                                  requiredStatus    : null,
                                                  comment           : null,
                                                  code              : 'p1',
                                                  active            : true,
                                                  creationDate      : new Date(),
                                                  basePrice         : soldProductPrice / 1.2,
                                                  taxRate           : 20,
                                                  priceWithTax      : soldProductPrice ,
                                                  discounts         : [],
                                                };

                    associatedProduct_variant = {
                                                  id                : 0,
                                                  name              : title,
                                                  complement        : '',
                                                  description       : '',
                                                  code              : 'v1',
                                                  barcode           : '',
                                                  active            : true,
                                                  creationDate      : new Date(),
                                                  stockAvailable    : 0,
                                                  stockBooked       : 0,
                                                  stockAssigned     : 0,
                                                  stockThreshold    : 0,
                                                  characteristics   : [],
                                                  medias            : [],
                                                  prices            : [associatedProduct_price],
                                                };
  
                    associatedProduct         = {
                                                  id                : 0,
                                                  uuid              : '',
                                                  publicRef         : '',
                                                  name              : title,
                                                  catchword         : '',
                                                  code              : '',
                                                  publicPortal      : false,
                                                  active            : true,
                                                  activeScheduled   : false,
                                                  activeStartDate   : null,
                                                  activeEndDate     : null,
                                                  creationDate      : new Date(),
                                                  lastUpdateDate    : null,
                                                  requiredStatus    : 'visitor',
                                                  requiredUserStatusId: 1,
                                                  paymentRequired   : true,
                                                  kind              : 'PayChannel',
                                                  description       : title,
                                                  variants          : [associatedProduct_variant],
                                                  characteristics   : [],
                                                  medias             : [],
                                                  categoriesIds     : [2],
                                                  associatedMediaId : 0,
                                                  associatedBroadcastingChannelId : 0,
                                                  associatedUserStatusId : 0,
                                                  associatedAdminResource : null
                                                };

                    return await createProduct ( associatedProduct, null, authentication.admin?.id )
                   }
	        }
	   else {
		     if ( initialAssociatedProduct )
		           {
		            await updateProductVisibility ( initialAssociatedProduct.id, false );
		           }

		     return handleError<number>(-1, 'not paid');
	        }
    };
                        
  const handleBroadcastingChannelCharacteristicsChange = ( updatedBroadcastingChannel    : EnrichedBroadcastingChannel ,
                                                           logoImageFileToUpload         : File | null                 ,
                                                           pendingImageFileToUpload      : File | null                 ,
                                                           pendingSoundFileToUpload      : File | null                 ,
                                                           logoImageMarkedForDeleting    : boolean                     ,
                                                           pendingImageMarkedForDeleting : boolean                     ,
                                                           pendingSoundMarkedForDeleting : boolean                     ,
                                                           paid                          : boolean                     ,
                                                           price                         : number                      ,
                                                           associatedProduct             : Product | null              ,
                                                           onComplete                    : (success: boolean) => void  ): void => {

    // Pas de pré-contrôle du quota ici : la fiche n'a pas le décompte des chaînes
    // EXISTANTES sur lequel porte le quota (nbChannelsUsed, lui, compte les chaînes
    // ACTIVES — ce n'est pas la même chose). Le serveur tranche, et son refus (409) est
    // affiché tel quel.
    //
    // Depuis le 2026-09-03, ce refus ne devrait plus se voir en pratique : la liste
    // (BroadcastingChannelList, handleNewBroadcastingChannelCreationClick) relit le
    // décompte et refuse d'ouvrir la fiche quand le quota est atteint. Le 409 reste le
    // filet — le serveur est le seul à faire autorité, et deux postes peuvent créer en
    // même temps.

    const activeBeforeSave = enrichedBroadcastingChannel.active;

    // Pendant l'enregistrement (envois de fichiers compris), le relevé périodique ne relit pas la
    // fiche : le serveur n'a pas encore les nouvelles valeurs et les ferait régresser. La fenêtre
    // se referme à la fin de l'enregistrement, réussi ou non.
    lastLocalWriteRef.current = Date.now() + 10 * 60 * 1000;
    const onCompleteOriginal = onComplete;
    onComplete = (success: boolean) => { lastLocalWriteRef.current = Date.now(); onCompleteOriginal(success); };

    setEnrichedBroadcastingChannel (updatedBroadcastingChannel);
    setShowWaitingIcon(true);

    const compute = async () => {
    
      let success = false;
	  
      const result_subscription = await saveAssociatedProduct ( paid                                                        ,
                                                                `Abonnement à la chaîne ${updatedBroadcastingChannel.name}` ,
                                                                price                                                       ,
                                                                associatedProduct                                           );

      let productIdsTab : number[] = [];
	  
      if ( result_subscription.code === 1 ) { productIdsTab.push ( result_subscription.payload  ); }

      const broadcastingChannelToSave : EnrichedBroadcastingChannel = {
        ...updatedBroadcastingChannel,
        associatedProductIds: productIdsTab
      };

      if (!isEditMode) 
            {
             const result = await createBroadcastingChannel ( broadcastingChannelToSave ,
                                                              logoImageFileToUpload     ,
                                                              pendingImageFileToUpload  ,
                                                              pendingSoundFileToUpload  ,
                                                              authentication.admin?.id  );

             if (result.code === 1) 
                   {
                    setBroadcastingChannelId (result.payload.id);
                    setEnrichedBroadcastingChannel ((prevState) => ({
                                                                      ...prevState,
                                                                      id   : result.payload.id   ,
                                                                      uuid : result.payload.uuid ,
                                                                   }));
                    setIsEditMode(true);
                    onCreated?.(result.payload.id);
                    success = true;
                    setShowWaitingIcon(false);
                    setInformationMessage(1);
                    setConfigSaveVersion(v => v + 1);
                    // nbChannelsUsed n'est pas touché ici : il suit les chaînes ACTIVES,
                    // et sert au décompte affiché dans le bandeau. Le quota de création,
                    // lui, est vérifié côté serveur sur le nombre de chaînes existantes.
                   }
              else {
                    setShowWaitingIcon(false);

                    // Sur un refus de quota, le serveur envoie la phrase à afficher : elle
                    // porte le décompte réel, que le front ne connaît pas.
                    if (result.code === 409) { setQuotaRefusalMessage(result.comment); }

                    setInformationMessage(result.code === 409 ? -4 : -1);
                   }
            }
       else {
             const result = await updateBroadcastingChannel ( broadcastingChannelToSave ,
                                                              logoImageFileToUpload     ,
                                                              pendingImageFileToUpload  ,
                                                              pendingSoundFileToUpload  ,
                                                              logoImageMarkedForDeleting    ,
                                                              pendingImageMarkedForDeleting ,
                                                              pendingSoundMarkedForDeleting ,
                                                              authentication.admin?.id     );

             if (result.code === 1)
                   {
                    setIsEditMode(true);
                    success = true;

                    const activeAfterSave = updatedBroadcastingChannel.active;

                    console.log('[régie] Transition active :', activeBeforeSave, '→', activeAfterSave);

                    if ( !activeAfterSave && activeBeforeSave )
                     {
                      console.log('[régie] → Arrêt détecté, nettoyage localStorage...');
                      clearMediartcLocalStorage();
                     }

                    if ( activeAfterSave && !activeBeforeSave )
                     {
                      console.log('[régie] → Démarrage détecté, nettoyage préventif localStorage...');
                      clearMediartcLocalStorage();
                     }

                    await reload();
                    setShowWaitingIcon(false);
                    setInformationMessage(2);
                    setConfigSaveVersion(v => v + 1);
                   }
              else {
                    setShowWaitingIcon(false);
                    setInformationMessage(result.code === 409 ? -3 : -2);
                   }
            }

      onComplete(success); 
    };

    compute ();
  };

  const handleNewBroadcastedMedia = (newBroadcastedMedia: TaggedEnrichedBroadcastedMedia) => {

    console.log ( "handleNewBroadcastedMedia" , buttonToClick);
      
    setEnrichedBroadcastingChannel((prevState) => ({
      ...prevState,
      broadcastedMedias: [...prevState.broadcastedMedias, newBroadcastedMedia],
    }));
    
    setTaggedEnrichedBroadcastedMedias((prev) => [...prev, newBroadcastedMedia]);

    setButtonToClick(true);
  };

  const handleBroadcastedMediasChange = (newBroadcastedMedias: TaggedEnrichedBroadcastedMedia[]) => {
      
    setTaggedEnrichedBroadcastedMedias(newBroadcastedMedias);
  };

  const handleUpdateChannelScheduleButton = () => {
      
    makeUpdateChannelSchedule();
  };

  const handleAckAnimationFinished = () => {
      
    setButtonToClick (false);
  };

  const makeUpdateChannelSchedule = async () => {

    setShowWaitingIcon(true);

    console.log(`[programmation] makeUpdateChannelSchedule : traitement de ${taggedEnrichedBroadcastedMedias.length} programme(s)`, taggedEnrichedBroadcastedMedias.map(m => ({ id: m.id, tag: m.tag, broadcastDate: m.broadcastDate })));

    // cf. déclaration de scheduleDriftNotice : on ne recale plus les heures des nouvelles
    // vidéos ("to create") — on respecte la programmation initiale telle que composée par
    // l'utilisateur ; le microservice ffmpeg (scheduler.py) traite lui-même les heures déjà
    // entamées ou dépassées (skip / démarrage en plein milieu), sans qu'on en avertisse
    // l'opérateur au clic sur "Enregistrer" — ce n'est pas une anomalie.
    // Vidéos créées en BDD mais que le microservice n'a pas programmées pour une raison
    // autre que l'heure dépassée (chemin vidéo introuvable, microservice injoignable) —
    // ce cas était totalement silencieux jusqu'ici.
    const notScheduledNotice  : string[] = [];
    // Vidéos déjà enregistrées dont la MODIFICATION a bien été prise en BDD, mais que le
    // microservice n'a pas pu reprogrammer — elles ont été retirées du planning et n'y sont
    // pas revenues (cf. statut 'not_rescheduled' de BroadcastedMediaUpdate).
    const notRescheduledNotice: string[] = [];
    // Vidéos REFUSÉES à la création par admin-api (fichier vidéo introuvable : leur diffusion
    // échouerait) — rien n'existe en base, il faut les retirer de la playlist locale.
    const refusedMedias       : TaggedEnrichedBroadcastedMedia[] = [];
    // Programmes dont la boucle n'a pas pu être enregistrée (admin-api injoignable).
    const loopFailedNotice    : string[] = [];

    // « Jouer en boucle » d'abord, à part (PATCH .../loop, jamais une reprogrammation : le
    // programme est souvent EN COURS). Avant les mises à jour d'heure : celles-ci reprogramment
    // en relisant la boucle en BDD. Une désactivation renvoie la fin EXACTE du tour en cours,
    // sur laquelle on recale les programmes suivants (setProgramLoop les avait calés sur une
    // fin relevée au moment du clic, qui a pu vieillir d'un tour depuis).
    let schedule = taggedEnrichedBroadcastedMedias;

    for (let i = 0; i < schedule.length; i++)
     {
      const loopChange = schedule[i];
      if (!loopChange.loopDirty || loopChange.id === 0) continue;

      const loopResult = await setBroadcastedMediaLoop(loopChange.id, loopChange.loop);
      if (loopResult.code !== 1) {
        loopFailedNotice.push(loopChange.title);
        continue;
      }

      schedule = schedule.map((m, j) => j === i ? { ...m, loopDirty: false } : m);

      if (!loopChange.loop && loopResult.payload.cycleEnd) {
        schedule = correctLoopRelease(schedule, i, loopResult.payload.cycleEnd.getTime());
      }
     }

    for (const broadcastedMedia of schedule)
     {
      if (broadcastedMedia.tag === "to create" && broadcastedMedia.broadcastDate) {
        const now = new Date();

        if (hasBroadcastWindowPassed(broadcastedMedia, now)) {
          console.warn(`[programmation] "${broadcastedMedia.title}" : heure prévue déjà entièrement dépassée, la vidéo ne sera pas diffusée.`);
        } else if (new Date(broadcastedMedia.broadcastDate) <= now) {
          console.warn(`[programmation] "${broadcastedMedia.title}" : heure prévue déjà entamée, la vidéo démarrera en cours (pas depuis le début).`);
        }
      }

      // Garde-fou avant toute suppression/archivage réel : même si le tag local dit
      // "missed"/"not found", on ne déclenche jamais l'archivage tant que la fenêtre de
      // diffusion affichée (broadcastDate → broadcastDate + duration) n'est pas terminée.
      // cf. hasBroadcastWindowPassed — protège contre un statut backend prématuré
      // (décalage du scheduler ffmpeg non répercuté sur broadcastDate en BDD).
      if ((broadcastedMedia.tag === "missed" || broadcastedMedia.tag === "not found") && !hasBroadcastWindowPassed(broadcastedMedia, new Date())) {
        console.warn(`[programmation] archivage annulé pour broadcastedMedia #${broadcastedMedia.id} (tag="${broadcastedMedia.tag}") : sa fenêtre de diffusion (broadcastDate=${broadcastedMedia.broadcastDate}) n'est pas encore terminée.`);
        continue;
      }

      switch (broadcastedMedia.tag)
       {
        case "not found"  : console.log(`[programmation] archivage de #${broadcastedMedia.id} (not found)`);
                            await archiveBroadcastedMedia(broadcastedMedia.id);
                            break;

        case "to archive" : console.log(`[programmation] archivage de #${broadcastedMedia.id} (to archive)`);
                            await archiveBroadcastedMedia(broadcastedMedia.id);
                            break;

        case "missed"     : console.log(`[programmation] archivage de #${broadcastedMedia.id} (missed)`);
                            await archiveBroadcastedMedia(broadcastedMedia.id);
                            break;

        case "to delete"  : console.log(`[programmation] suppression de #${broadcastedMedia.id} (to delete)`);
                            await deleteBroadcastedMedia(broadcastedMedia.id);
                            break;
                            
        case "to create"  : {
                              // « Lire maintenant » part à l'envoi, pas au clic sur « Confirmer » :
                              // l'heure affichée doit être celle qu'admin-api retiendra (la sienne).
                              if ( broadcastedMedia.priority ) broadcastedMedia.broadcastDate = new Date();
                              const creationResult = await addBroadcastedMedia(broadcastingChannelId, broadcastedMedia);
                              // Sans ceci, l'item restait id=0/tag="to create" indéfiniment (cf.
                              // bug de statut HTTP corrigé dans addBroadcastedMedia) et se faisait
                              // recréer en BDD à chaque nouveau clic sur "Mettre à jour le
                              // programme". On rattache ici l'id réel et on retire le tag local
                              // pour que reload() puisse le reconcilier avec le statut backend.
                              //
                              // ⚠️ Ce rattachement doit avoir lieu MÊME quand le microservice n'a
                              // pas programmé la vidéo (payload.scheduled === false, ex. heure déjà
                              // dépassée) : la ligne existe bel et bien en BDD. Sans cela, l'item
                              // local restait affiché à côté de la ligne revenue du serveur — même
                              // vidéo, deux statuts ("Nouveau" + "Non diffusé") — et une nouvelle
                              // ligne était créée à chaque clic (constaté le 29/07/2026).
                              if ( creationResult.code === 1 && creationResult.payload.broadcastedMediaId )
                               {
                                broadcastedMedia.id  = creationResult.payload.broadcastedMediaId;
                                broadcastedMedia.tag = "";

                                // L'heure dépassée n'est plus signalée à l'opérateur (ce n'est pas
                                // une anomalie) : on ne signale ici que les autres causes de non-programmation.
                                if ( !creationResult.payload.scheduled && !hasBroadcastWindowPassed(broadcastedMedia, new Date()) )
                                 {
                                  notScheduledNotice.push(broadcastedMedia.title);
                                 }
                               }
                              else if ( creationResult.code === 422 )
                               {
                                console.warn(`[programmation] "${broadcastedMedia.title}" refusée : ${creationResult.comment}`);
                                refusedMedias.push(broadcastedMedia);
                               }
                              break;
                            }
                            
        case "to update"  : {
                              const updateResult = await updateBroadcastedMedia(broadcastingChannelId, broadcastedMedia);

                              // La ligne est à jour en BDD, mais admin-api l'avait retirée du
                              // planning du microservice pour la reprogrammer et n'a pas pu l'y
                              // remettre : elle ne sera pas diffusée bien qu'affichée "En attente".
                              // Ce cas était renvoyé en HTTP 200 'success' et totalement silencieux
                              // avant l'ajout du statut 'not_rescheduled' côté admin-api.
                              if ( updateResult.code === 1 && !updateResult.payload.rescheduled )
                               {
                                notRescheduledNotice.push(broadcastedMedia.title);
                               }
                              break;
                            }
      }
    }

    setButtonToClick (false);

    // Retire de la playlist locale les vidéos refusées. Ce doit être fait AVANT reload() : celui-ci
    // préserve exprès tout item id===0 (pas encore sauvegardé), il garderait donc ces vidéos à
    // l'écran, et elles seraient resoumises — et refusées — à chaque clic suivant. Reconnues par
    // média + heure (l'item n'a pas d'id) : la même vidéo à une autre heure reste en place.
    if (refusedMedias.length > 0) {
      const isRefused = (m: TaggedEnrichedBroadcastedMedia) =>
        m.id === 0 && refusedMedias.some(r => r.mediaId === m.mediaId && String(r.broadcastDate) === String(m.broadcastDate));

      setTaggedEnrichedBroadcastedMedias(prev => prev.filter(m => !isRefused(m)));
      setEnrichedBroadcastingChannel(prev => ({
        ...prev,
        broadcastedMedias: prev.broadcastedMedias.filter(m => !isRefused(m as TaggedEnrichedBroadcastedMedia)),
      }));
    }

    // Un seul message pour tous les avertissements : setScheduleDriftNotice écrase, donc
    // deux appels successifs feraient disparaître le premier avertissement.
    const notices: string[] = [];

    if (refusedMedias.length > 0) {
      notices.push(
        `${refusedMedias.length === 1 ? "La vidéo n'a pas été ajoutée" : `${refusedMedias.length} vidéos n'ont pas été ajoutées`} à la playlist : ` +
        `${refusedMedias.map(m => `« ${m.title} »`).join(', ')} — ` +
        `${refusedMedias.length === 1 ? 'son fichier vidéo est introuvable' : 'leurs fichiers vidéo sont introuvables'} sur le serveur média, ` +
        `la diffusion échouerait.`
      );
    }

    if (notScheduledNotice.length > 0) {
      notices.push(
        `${notScheduledNotice.length} vidéo(s) ont été enregistrées mais n'ont pas pu être ` +
        `programmées pour la diffusion (${notScheduledNotice.join(', ')}) — elles apparaissent ` +
        `en "Non diffusé". Vérifiez que le fichier vidéo est disponible et que la chaîne diffuse.`
      );
    }

    if (notRescheduledNotice.length > 0) {
      notices.push(
        `⚠️ ${notRescheduledNotice.length} vidéo(s) ont bien été modifiées mais n'ont pas pu être ` +
        `reprogrammées pour la diffusion (${notRescheduledNotice.join(', ')}) : elles ne passeront ` +
        `PAS à l'antenne, bien qu'affichées "En attente". Modifiez à nouveau leur heure pour ` +
        `relancer la programmation, après avoir vérifié que la chaîne diffuse.`
      );
    }

    if (loopFailedNotice.length > 0) {
      notices.push(
        `La lecture en boucle n'a pas pu être enregistrée pour ${loopFailedNotice.map(t => `« ${t} »`).join(', ')} : ` +
        `réessayez.`
      );
    }

    if (notices.length > 0) {
      setScheduleDriftNotice(notices.join(' '));
    }

    await reload();

    setShowWaitingIcon(false);
  };

  const handleInformationAckButton = () => {
      
    setInformationMessage (0);
  };

  const [currentNextHash, setCurrentNextHash] = useState<string>('');

  const reloadCurrentAndNext = useCallback(async () => {
    if (!isEditMode || !broadcastingChannelId) {
      console.log('❌ reloadCurrentAndNext: mode ou ID invalide', { isEditMode, broadcastingChannelId });
      return;
    }

    console.log('🔄 reloadCurrentAndNext appelé pour channel', broadcastingChannelId);

    try {
      const result = await getCurrentAndNextBroadcastedMedias(
        broadcastingChannelId,
        currentNextHash
      );
      
      if (result.code !== 1) {
        console.log('❌ Erreur API:', result.comment);
        return;
      }

      if (!result.hasChanged) {
        console.log('✓ Aucun changement (hash identique)');
        return;
      }

      console.log('✅ Changements détectés, mise à jour...');
      
      if (result.hash) {
        setCurrentNextHash(result.hash);
      }

      const { current, next } = result.payload;

      setTaggedEnrichedBroadcastedMedias(prevMedias => {
        return prevMedias.map(localMedia => {
          if (localMedia.id === 0) return localMedia;
          
          if (localMedia.tag === "to delete" || 
              localMedia.tag === "to update" || 
              localMedia.tag === "to create") {
            return localMedia;
          }

          // `current`/`next` sont partiels (initializedEnrichedBroadcastedMedia : loop=false) :
          // sans cette reprise, un programme en boucle s'afficherait désarmé à chaque sondage.
          // Idem pour « Lire maintenant » : le voile de ce qu'il recouvre en dépend.
          const loopFields = { loop: localMedia.loop, loopDirty: localMedia.loopDirty, loopCycleEnd: localMedia.loopCycleEnd, priority: localMedia.priority };

          if (current && localMedia.id === current.id) {
            return {
              ...localMedia,
              ...current,
              ...loopFields,
              tag: "current",
              oldTag: "",
            };
          }

          if (next && localMedia.id === next.id) {
            return {
              ...localMedia,
              ...next,
              ...loopFields,
              tag: "queued",
              oldTag: "",
            };
          }

          if (localMedia.tag === "current" && current?.id !== localMedia.id) {
            return {
              ...localMedia,
              tag: "to archive",
              oldTag: "current",
            };
          }

          return localMedia;
        });
      });

    } catch (error) {
      console.error("❌ Erreur lors du reloadCurrentAndNext:", error);
    }
  }, [isEditMode, broadcastingChannelId, currentNextHash]);	 
		 
  const handleThirdPartyStreamingSystemChange = ( newChannels : ThirdPartyStreamingChannel [] ) => {
    setThirdPartyStreamingChannels (newChannels);
  };

  const confirmStreamSource = useCallback((newSource: StreamSource) => {
    console.log('[confirmStreamSource] appelé avec', newSource);
    setStreamSource(newSource);
    setEnrichedBroadcastingChannel(prev => ({
      ...prev,
      streamSource: newSource,
      mode: newSource === 'video' ? 'Delayed' : 'Live',
    }));
  }, []);

  // ── Dérivés pour le Dashboard ─────────────────────────────────────────────
  const dashboardKw = keywordSet.filter(k =>
    (enrichedBroadcastingChannel.keywordsIds ?? []).includes(k.id)
  );

  const dashboardCategoryLabel = bcCategories
    .filter(c => (enrichedBroadcastingChannel.categoriesIds ?? []).includes(c.id))
    .map(c => c.name)
    .join(', ');

  const dashboardAccessLabel = (enrichedBroadcastingChannel.requiredUserStatusId ?? 0) > 0
    ? (userStatuses.find(s => s.id === enrichedBroadcastingChannel.requiredUserStatusId)?.name ?? '')
    : 'Accès libre';

  // Rappel du nom de la chaîne, affiché à droite de la barre d'onglets sur les
  // onglets de travail. Le Tableau de bord l'affiche déjà en titre : l'y remettre
  // ferait doublon, il ne le reçoit donc pas.
  // En création, le nom n'est pas encore saisi : on n'affiche rien plutôt qu'un
  // libellé vide.
  const rappelNomChaine = (enrichedBroadcastingChannel.name ?? '').trim() !== ''
    ? (
        <span className = {classNames(styles.channelReminder)}>
          <span className = {classNames(styles.channelReminderLabel)}>Chaîne&nbsp;:&nbsp;</span>
          {enrichedBroadcastingChannel.name}
        </span>
      )
    : null;

  // Index de l'onglet "Programmation" / "Régie" dans le tableau `tabs` du Tabs2 ci-dessous.
  const PROGRAMMATION_TAB_INDEX = 2;
  const REGIE_TAB_INDEX         = 3;

  // « Actions rapides » du tableau de bord : onglet à ouvrir (+ YouTube présélectionné dans Restream).
  const [focusYoutube, setFocusYoutube] = useState(0);
  const handleDashboardNavigate = (index: number, focus?: 'youtube') => {
    // Chaîne éphémère : Configuration et Régie sont fermées (onglets `disabled` plus bas).
    if (enrichedBroadcastingChannel.ephemeral && (index === 1 || index === REGIE_TAB_INDEX)) return;
    handleTabChange(index);
    if (focus === 'youtube') setFocusYoutube(n => n + 1);
  };
  // Changement d'onglet à la main : la demande YouTube est oubliée, sinon l'onglet
  // Restream (démonté puis remonté) re-préremplirait YouTube à chaque retour.
  const handleTabClick = (index: number) => {
    setFocusYoutube(0);
    handleTabChange(index);
  };

  const handleTabChange = (index: number) => {
    setActiveTabIndex(index);
    // En arrivant sur l'onglet, on déclenche le même traitement que le bouton "Mettre à
    // jour le programme" : au-delà du simple rechargement, les anciens programmes déjà
    // marqués "à archiver"/"non diffusé"/"introuvable" mais pas encore réellement archivés
    // côté backend le sont maintenant, sans attendre un clic manuel de l'opérateur.
    if (index === PROGRAMMATION_TAB_INDEX) makeUpdateChannelSchedule();
    // `channelStatus` plutôt que le booléen `active` (optimiste, bascule au clic avant même
    // que le backend ait commencé) : sans cette distinction, entrer dans l'onglet Régie juste
    // après avoir cliqué "Activer" montrait "La chaîne n'est pas activée" alors qu'elle était
    // déjà en train de l'être — message qui contredit ce que l'opérateur vient de faire.
    if (index === REGIE_TAB_INDEX) {
      if (channelStatus === 'inactive') {
        setPublishOnPortalWithActivation(true);
        setRegieInactiveNotice("La chaîne n'est pas activée. Voulez-vous l'activer maintenant pour pouvoir utiliser la régie ?");
      } else if (channelStatus === 'activating' || channelStatus === 'activating_restricted') {
        // Pas d'action à proposer ici : la connexion WHIP se fait d'elle-même dès que
        // `channelStatus` atteint 'active' (cf. l'effet ci-dessous et LiveStreamManager,
        // qui réagit au passage de channelActive à true) — le message se referme tout seul.
        setRegieInactiveNotice("La chaîne est en cours d'activation. La régie se connectera automatiquement dans quelques secondes.");
      } else if (channelStatus === 'deactivating' || channelStatus === 'deactivating_restricted') {
        setRegieInactiveNotice("La chaîne est en cours de désactivation.");
      } else if (channelStatus === 'error') {
        setRegieInactiveNotice("La chaîne est en erreur. Vérifiez son état avant d'utiliser la régie.");
      }
    }
  };

  // Referme automatiquement le message d'attente affiché ci-dessus dès que le polling de
  // l'effet "Polling pendant les états transitoires" confirme la chaîne prête — l'opérateur
  // n'a rien à cliquer, contrairement au cas 'inactive'/'deactivating'/'error' où le message
  // reste jusqu'à un clic sur Ok.
  useEffect(() => {
    if (regieInactiveNotice === null) return;
    if (channelStatus === 'active' || channelStatus === 'restricted') setRegieInactiveNotice(null);
  }, [channelStatus, regieInactiveNotice]);

  return (
           <SourceSwitchingContext.Provider value={sourceSwitching}>
            <div className = {classNames(styles.root)}>

              { 
               showWaitingIcon && 
               <>
                 <div className={classNames(styles.overlay)} />
                 <AnimatedWaitingIcon2 />
               </>
              }

              {
               informationMessage === 1 &&
               <Window message                 = {<>
                                                    La chaîne a été créée. Voulez-vous l'activer maintenant ?
                                                    {!publicPortal &&
                                                     <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 14, cursor: 'pointer' }}>
                                                       <input type     = "checkbox"
                                                              checked  = {publishOnPortalWithActivation}
                                                              onChange = {(e) => setPublishOnPortalWithActivation(e.target.checked)} />
                                                       Afficher aussi la chaîne sur le portail public
                                                     </label>}
                                                   </>}
                       messageType             = "question"
                       onClickOnValidateButton = {() => { activateAndMaybePublish(); handleInformationAckButton(); onCreationDone?.(); }}
                       onClickOnCancelButton   = {() => { handleInformationAckButton(); onCreationDone?.(); }}
                       validButtonText         = "Activer"
                       cancelButtonText        = "Plus tard"
                       width                   = "400px" />
              }

              {
               sourceFallback &&
               <Window message                 = {
                         sourceFallback.lost
                         ? <>
                            {sourceFallback.requested === 'rtmp'
                              ? <>Le flux OBS (RTMP) a été perdu. </>
                              : <>Le flux de la source a été perdu. </>}
                            La chaîne a été rebasculée sur la playlist.<br /><br />
                            {sourceFallback.requested === 'rtmp'
                              ? <>Relancez le streaming dans OBS et attendez qu'il soit connecté, puis sélectionnez de nouveau la source.</>
                              : <>Vérifiez que la source émet de nouveau, puis sélectionnez-la de nouveau.</>}
                           </>
                         : <>
                            {sourceFallback.requested === 'rtmp'
                              ? <>Le flux OBS (RTMP) n'est pas disponible : aucun signal n'a été reçu sur la chaîne. </>
                              : <>La source demandée n'est pas disponible : aucun signal n'a été reçu. </>}
                            La chaîne est restée sur la playlist.<br /><br />
                            {sourceFallback.requested === 'rtmp'
                              ? <>Démarrez le streaming dans OBS et attendez qu'il soit connecté, puis sélectionnez de nouveau la source.</>
                              : <>Vérifiez que la source émet, puis sélectionnez-la de nouveau.</>}
                           </>
                       }
                       messageType             = "information"
                       onClickOnValidateButton = {() => setSourceFallback(null)}
                       validButtonText         = "Ok"
                       width                   = "420px" />
              }

              {
               informationMessage === 2 &&
               <Window message                 = {<>Les informations ont été modifiées</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Ok" />
              }

              {
               informationMessage === -1 &&
               <Window message                 = {<>Une erreur est survenue lors de la création de la chaîne</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Ok" />
              }

              {
               informationMessage === -2 &&
               <Window message                 = {<>Une erreur est survenue lors de la modification de la chaîne</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Ok" />
              }

              {
               informationMessage === -3 &&
               <Window message                 = {<>Ce nom de chaîne génère un slug déjà utilisé par une autre chaîne</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Ok" />
              }

              {
               informationMessage === -4 &&
               <Window message                 = {
                                                  quotaRefusalMessage !== ''
                                                  ? <>{quotaRefusalMessage}</>
                                                  : <>Quota de chaînes atteint. Supprimez une chaîne existante avant d'en créer une nouvelle, ou augmentez votre quota de chaînes.</>
                                                 }
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Fermer"
                       extraButtonText         = {BUY_CHANNEL_LABEL}
                       onClickOnExtraButton    = {() => openBuyChannel(setPurchaseNotice)}
                       width                   = "min(560px, 92vw)" />
              }

              {
               informationMessage === -5 &&
               <Window message                 = {<>Limite de chaînes actives atteinte ({authentication.admin?.nbChannelsUsed}/{afficherLimite(authentication.admin?.nbChannelsMax ?? 0)}). Désactivez une autre chaîne avant d'activer celle-ci, ou augmentez votre quota de chaînes.</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Fermer"
                       extraButtonText         = {BUY_CHANNEL_LABEL}
                       onClickOnExtraButton    = {() => openBuyChannel(setPurchaseNotice)}
                       width                   = "min(560px, 92vw)" />
              }

              {
               informationMessage === -6 &&
               <Window message                 = {<>Quota de durée de diffusion cumulée atteint ({formatDurationInSeconds(authentication.admin?.durationElapsedBroadcasting ?? 0)}/{formatDurationInSeconds(authentication.admin?.durationMaxBroadcasting ?? 0)}). Impossible d'activer cette chaîne tant que le quota n'est pas renouvelé ou augmenté.</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Fermer"
                       extraButtonText         = {BUY_BROADCASTING_DURATION_LABEL}
                       onClickOnExtraButton    = {() => openBuyBroadcastingDuration(setPurchaseNotice)}
                       width                   = "min(560px, 92vw)" />
              }

              {
               informationMessage === -7 &&
               <Window message                 = {<>{lockRefusal}</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleInformationAckButton}
                       validButtonText         = "Fermer"
                       width                   = "min(560px, 92vw)" />
              }

              {
               // Compte rendu de l'achat, au-dessus de la fenêtre de quota qui reste ouverte
               // derrière : le zIndex par défaut (600) les superposerait dans le désordre.
               purchaseNotice !== '' &&
               <Window message                 = {<>{purchaseNotice}</>}
                       messageType             = "information"
                       onClickOnValidateButton = {() => setPurchaseNotice('')}
                       validButtonText         = "Ok"
                       zIndex                  = {700}
                       width                   = "min(560px, 92vw)" />
              }

              {
               deactivationNotice !== null &&
               <Window message                 = {<>{deactivationNotice}</>}
                       messageType             = "information"
                       onClickOnValidateButton = {() => setDeactivationNotice(null)}
                       validButtonText         = "Ok" />
              }

              {
               regieInactiveNotice !== null &&
               (
                channelStatus === 'inactive'
                ? <Window message                 = {<>
                                                       {regieInactiveNotice}
                                                       {/* Rien à proposer si la chaîne est déjà sur le portail. */}
                                                       {!publicPortal &&
                                                        <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 14, cursor: 'pointer' }}>
                                                          <input type     = "checkbox"
                                                                 checked  = {publishOnPortalWithActivation}
                                                                 onChange = {(e) => setPublishOnPortalWithActivation(e.target.checked)} />
                                                          Afficher aussi la chaîne sur le portail public
                                                        </label>}
                                                      </>}
                          messageType             = "question"
                          validButtonText         = "Oui"
                          cancelButtonText        = "Non"
                          onClickOnValidateButton = {() => {
                                                       // Même transition que l'entrée directe sur l'onglet Régie
                                                       // pendant une activation (cf. branche 'activating' ci-dessus).
                                                       activateAndMaybePublish();
                                                       setRegieInactiveNotice("La chaîne est en cours d'activation. La régie se connectera automatiquement dans quelques secondes.");
                                                      }}
                          onClickOnCancelButton   = {() => setRegieInactiveNotice(null)} />
                : (channelStatus === 'activating' || channelStatus === 'activating_restricted')
                ? <Window message     = {<>{regieInactiveNotice}<div style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }}><AnimatedWaitingIcon2 size={40} overlay={false} /></div></>}
                          messageType = "information" />
                : <Window message                 = {<>{regieInactiveNotice}</>}
                          messageType             = "information"
                          onClickOnValidateButton = {() => setRegieInactiveNotice(null)}
                          validButtonText         = "Ok" />
               )
              }

              {
               scheduleDriftNotice !== null &&
               <Window message                 = {<>{scheduleDriftNotice}</>}
                       messageType             = "information"
                       onClickOnValidateButton = {() => setScheduleDriftNotice(null)}
                       validButtonText         = "Ok" />
              }

              <div className = {classNames(styles.contain)}>
                <Tabs2 onChange        = {handleTabClick}
                       initialTabIndex = {isEditMode ? (initialTabIndex ?? 0) : 1}
                       activeTabIndex  = {activeTabIndex}
				       tabs = {[
                                 // {
                                  // label: 'Ancienne configuration',
                                  // keepMounted: true, 
                                  // children: 
								            // <div className = {classNames(styles.panelLevel1)}>
                                              // <BroadcastingChannelCharacteristics broadcastingChannelToEdit    = {enrichedBroadcastingChannel}
                                        // onBroadcastingChannelChange = {handleBroadcastingChannelCharacteristicsChange}
                                        // creationMode                = {!isEditMode}
                                        // onReady                     = {handleReady}
                                        // streamSource                 = {streamSource}
                                        // defaultStreamSource          = {defaultStreamSource}
                                        // onStreamSourceChange         = {handleSourceChange}
                                        // onDefaultStreamSourceChange  = {handleDefaultSourceChange}
                                        // isActive                     = {activeTabIndex === 0}
                                        // hlsVolume                    = {hlsVolume}
                                        // hlsMuted                     = {hlsMuted}
                                        // onHlsVolumeChange            = {handleHlsVolumeChange}
                                        // onHlsMutedChange             = {handleHlsMutedChange}
                                        // hlsMonitorStream             = {hlsMonitorStream}
                                        // hlsAudioRegistry             = {hlsAudioRegistry}
                                        // hlsAudioSourceId             = {hlsAudioSourceId}
                                        // onHlsReset                   = {resetMonitorStream}
                                         // />
                                            // </div>
                                 // },
                                 {
                                  label: 'Tableau de bord',
                                  keepMounted: true, 
                                  children: 
                                    <div className = {classNames(styles.panelLevel1)}>
                                      <BroadcastingChannelDashboard
                                        broadcastingChannelToEdit    = {enrichedBroadcastingChannel}
                                        streamSource                 = {streamSource}
                                        defaultStreamSource          = {defaultStreamSource}
                                        onStreamSourceChange         = {handleSourceChange}
                                        onDefaultStreamSourceChange  = {handleDefaultSourceChange}
                                        isActive                     = {activeTabIndex === 0}
                                        hlsVolume                    = {hlsVolume}
                                        hlsMuted                     = {hlsMuted}
                                        onHlsVolumeChange            = {handleHlsVolumeChange}
                                        onHlsMutedChange             = {handleHlsMutedChange}
                                        hlsMonitorStream             = {hlsMonitorStream}
                                        hlsAudioRegistry             = {hlsAudioRegistry}
                                        hlsAudioSourceId             = {hlsAudioSourceId}
                                        onHlsReset                   = {resetMonitorStream}
                                        taggedBroadcastedMedias      = {taggedEnrichedBroadcastedMedias}
                                        active                       = {active}
                                        channelStatus                = {displayChannelStatus}
                                        xtreamViewerCount            = {xtreamViewerCount}
                                        publicPortal                 = {publicPortal}
                                        onActiveToggle               = {handleActiveToggle}
                                        onPortalChange               = {handlePortalChange}
                                        metricsEnabled               = {metricsEnabled}
                                        metricsReachable             = {metricsReachable}
                                        onMetricsToggle              = {handleMetricsToggle}
                                        keywords                     = {dashboardKw}
                                        categoryLabel                = {dashboardCategoryLabel}
                                        accessLabel                  = {dashboardAccessLabel}
                                        onCreateChannel              = {onCreateChannel}
                                        onNavigateTab                = {handleDashboardNavigate}
                                      />
                                    </div>
                                 },
                                 {
                                  label: 'Configuration',
                                  keepMounted: true,
                                  headerRight: rappelNomChaine,
                                  // Chaîne éphémère : cf. l'onglet Régie plus bas, même principe — seul
                                  // Tableau de bord reste ouvert pour ces chaînes.
                                  disabled: enrichedBroadcastingChannel.ephemeral,
                                  disabledMessage: "Cette chaîne n'a pas été créée à partir de cet emplacement. Cette fonctionnalité n'est pas accessible.",
                                  children: enrichedBroadcastingChannel.ephemeral
                                    ? <div className = {classNames(styles.panelLevel1)} style = {{ padding: '2rem', textAlign: 'center' }}>
                                        Cette chaîne est éphémère : elle est gérée ailleurs, la configuration n'est pas modifiable ici.
                                      </div>
                                    : <div className = {classNames(styles.panelLevel1)}>
                                        <BroadcastingChannelConfig
                                          broadcastingChannelToEdit   = {enrichedBroadcastingChannel}
                                          onBroadcastingChannelChange = {handleBroadcastingChannelCharacteristicsChange}
                                          creationMode                = {!isEditMode}
                                          onCancel                    = {onCancel}
                                          onReady                     = {handleReady}
                                          defaultPendingImage         = {defaultPendingImage || undefined}
                                          saveVersion                 = {configSaveVersion}
                                        />
                                      </div>
                                 },
                                 // {
                                   // label: 'Programmation v1',
                                   // children: <>
                                               // {
                                                 // isEditMode &&
                                                 // ready      &&
                                                 // (
                                                  // <div className = {classNames(styles.panelLevel1)}>
                                                    // <div className = {classNames(styles.creationPart)}>
                                                      // <BroadcastedMediaCreation mediaSet                             = {mediaSet}
                                                                                // mediaCategories                      = {categorySet}
                                                                                // broadcastingChannelId                = {broadcastingChannelId}
                                                                                // enrichedBroadcastingChannel          = {enrichedBroadcastingChannel}
                                                                                // dateAndTimeAfterLastBroadcastedMedia = {convertDateToString(getDateAndTimeAfterLastBroadcastedMedia(), 'dd/MM/yyyy HH:mm:ss')}
                                                                                // onNewBroadcastedMedia                = {handleNewBroadcastedMedia} />
                                                    // </div>

                                                    // <div className = {classNames(styles.buttons_block)}>

                                                      // {
													   // !enrichedBroadcastingChannel.active && 
													   // (
                                                        // <div className={classNames(styles.inactiveWarning)}>
                                                          // ⚠️ La chaîne est inactive — les programmes ne seront pas diffusés.
                                                        // </div>
                                                       // )
													  // }
                                                      
													  // <br />
 
                                                      // {
                                                       // enrichedBroadcastingChannel.broadcastedMedias.length > 0 &&
                                                       // (
                                                        // <Trigger name                   = "Mettre à jour"
                                                                 // onClick                = {handleUpdateChannelScheduleButton}
                                                                 // variant                = "tailwind2"
                                                                 // toClick                = {buttonToClick}
                                                                 // ackAnimation           = {true}
                                                                 // onAckAnimationFinished = {handleAckAnimationFinished} />
                                                       // )
                                                      // }

                                                    // </div>

                                                    // <div className = {classNames(styles.listPart)}>
                                                      // {
                                                       // taggedEnrichedBroadcastedMedias.length > 0
                                                       // ?
                                                       // (
                                                        // <BroadcastedMediaList broadcastedMedias         = {taggedEnrichedBroadcastedMedias} 
                                                                              // onBroadcastedMediasChange = {handleBroadcastedMediasChange}
                                                                              // onStatusUpdate            = {reloadCurrentAndNext}
                                                                              // pollingInterval           = {15000}
                                                                              // enablePolling             = {true} />													   
                                                       // )
                                                       // :
                                                       // (
                                                        // <div className = {styles.noDataMessage}>
                                                          // Aucun programme à afficher
                                                        // </div>
                                                       // )
                                                      // }
                                                    // </div>
                                                  // </div>
                                                 // )
                                               // }
                                             // </>
                                 // },
                                 {
                                   label: 'Programmation',
                                   headerRight: rappelNomChaine,
                                   children: (
                                     <>
                                       {isEditMode && ready && (
                                         <div className={classNames(styles.panelLevel1)}>
                                           <BroadcastedMediaListV2
                                             broadcastedMedias         = {taggedEnrichedBroadcastedMedias}
                                             onBroadcastedMediasChange = {handleBroadcastedMediasChange}
                                             onStatusUpdate            = {reloadCurrentAndNext}
                                             pollingInterval           = {15000}
                                             enablePolling             = {true}
                                             mediaSet                             = {mediaSet}
                                             onRefreshMedias                      = {async () => {
                                               // Le catalogue est une photo prise à l'ouverture de la chaîne : les réglages
                                               // d'une fiche vidéo modifiés depuis n'y sont pas. On relit les vidéos.
                                               const fresh = await getMediaList(['Video'], authentication.admin?.id);
                                               if (fresh.code !== 1 || !fresh.payload) return null;
                                               const merged = [...mediaSet.filter(m => m.mediaType !== 'Video'), ...fresh.payload];
                                               setMediaSet(merged);
                                               return merged;
                                             }}
                                             mediaCategories                      = {categorySet}
                                             broadcastingChannelId                = {broadcastingChannelId}
                                             enrichedBroadcastingChannel          = {enrichedBroadcastingChannel}
                                             dateAndTimeAfterLastBroadcastedMedia = {convertDateToString(getDateAndTimeAfterLastBroadcastedMedia(), 'dd/MM/yyyy HH:mm:ss')}
                                             onNewBroadcastedMedia                = {handleNewBroadcastedMedia}
                                             onSaveSchedule         = {handleUpdateChannelScheduleButton}
                                             buttonToClick          = {buttonToClick}
                                             onAckAnimationFinished = {handleAckAnimationFinished}
                                             channelActive = {enrichedBroadcastingChannel.active}
                                           />
                                         </div>
                                       )}
                                     </>
                                   )
                                 },
                                 {
                                  label: 'Régie',
                                  keepMounted: true,
                                  // Le bouton « Public » (StageRequestsDock) s'y accroche, à gauche du nom de la chaîne.
                                  headerRight: rappelNomChaine
                                    ? <><span id = "stage-dock-slot" style = {{ display: 'flex', alignItems: 'center', marginRight: 14 }} />{rappelNomChaine}
                                        {/* Chaîne active : spectateurs de la dernière minute, le compteur de Kleon.tv (relevé toutes les 15 s). */}
                                        {typeof xtreamViewerCount === 'number' && (
                                          <span className = {classNames(styles.viewerPill)}
                                                title     = "Spectateurs connectés au flux dans la dernière minute (même compteur que Kleon.tv)">
                                            <span className = {classNames(styles.viewerDot, xtreamViewerCount > 0 && styles.viewerDotLive)} />
                                            {xtreamViewerCount}&nbsp;<span className = {classNames(styles.channelReminderLabel)}>{xtreamViewerCount > 1 ? 'spectateurs' : 'spectateur'}</span>
                                          </span>
                                        )}</>
                                    : null,
                                  // Chaîne éphémère : créée et pilotée par un autre système. Monter la régie ici
                                  // ouvrirait la webcam et les devices pour une chaîne dont elle ne voit rien
                                  // (constaté le 20/09/2026 en changeant de chaîne). Le drapeau vient de la base,
                                  // posé à la main (BroadcastingChannel.ephemeral).
                                  disabled: enrichedBroadcastingChannel.ephemeral,
                                  disabledMessage: "Cette chaîne n'a pas été créée à partir de cet emplacement. Cette fonctionnalité n'est pas accessible.",
                                  children: enrichedBroadcastingChannel.ephemeral
                                    ? <div className = {classNames(styles.panelLevel1)} style = {{ padding: '2rem', textAlign: 'center' }}>
                                        Cette chaîne est éphémère : elle est gérée ailleurs, la régie n'y est pas disponible.
                                      </div>
                                    : <div className = {classNames(styles.panelLevel1)}>
                                              <LiveStreamManagerBootstrap
                                                broadcastingChannel          = {enrichedBroadcastingChannel}
                                                streamSource                 = {streamSource}
                                                defaultStreamSource          = {defaultStreamSource}
                                                onStreamSourceChange         = {handleSourceChange}
                                                onDefaultStreamSourceChange  = {handleDefaultSourceChange}
                                                onStopStreaming              = {handleStopStreaming}
                                                hlsVolume                    = {hlsVolume}
                                                hlsMuted                     = {hlsMuted}
                                                onHlsVolumeChange            = {handleHlsVolumeChange}
                                                onHlsMutedChange             = {handleHlsMutedChange}
                                                channelSignalConfirmed       = {hlsHasSignal}
                                                onLiveStatusChange           = {(s) => { liveStatusRef.current = s; }}
												onRegisterStart = {(fn) => { liveStreamStartRef.current = fn; }}
											    onRegisterStop  = {(fn) => { liveStreamStopRef.current  = fn; }}
												onConfirmStreamSource        = {confirmStreamSource}
												hlsMonitorStream = {hlsMonitorStream}
												hlsAudioRegistry   = {hlsAudioRegistry}
                                                hlsAudioSourceId   = {hlsAudioSourceId}
                                                onHlsReset = {resetMonitorStream}	
                                              />
                                            </div>
                                 },
                                 // {
                                  // label: 'Restream v1',
                                  // children: <div className = {classNames(styles.panelLevel1)}>
                                              // <BroadcastingChannelCharacteristics_ThirdPartyStreamingSystem
                                                // broadcastingChannelId             = {broadcastingChannelId}
                                                // broadcastingChannelName           = {enrichedBroadcastingChannel.name}
                                                // thirdPartyStreamingChannelsToEdit = {thirdPartyStreamingChannels}
                                                // onChange                          = {handleThirdPartyStreamingSystemChange}
                                              // />
                                             // </div>
                                 // },								 
                                 {
                                  label: 'Restream',
                                  headerRight: rappelNomChaine,
                                  children: <div className = {classNames(styles.panelLevel1)}>
                                              <BroadcastingChannelCharacteristics_ThirdPartyStreamingSystemV2
                                                broadcastingChannelId             = {broadcastingChannelId}
                                                broadcastingChannelName           = {enrichedBroadcastingChannel.name}
                                                thirdPartyStreamingChannelsToEdit = {thirdPartyStreamingChannels}
                                                onChange                          = {handleThirdPartyStreamingSystemChange}
                                                focusYoutube                      = {focusYoutube}
                                              />
                                             </div>
                                 },
                              ]}
                />
              </div>
            </div>
           </SourceSwitchingContext.Provider>
         );
};

export default BroadcastingChannelSheet;